// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT_PROFILE: `Thông tin tài khoản`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    ADA_TOGGLE_ON: `Chạm để thu nhỏ màn hình`,
    ADA_TOGGLE_OFF: `Chạm để dừng thu nhỏ màn hình`,
    ADD: `Add`,
    ADD_DONATION: `Thêm quyên góp`,
    ADD_FUNDS: `Thêm tiền tại đây`,
    ADD_TIP: `Thêm tiền tip`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `Thêm vào giỏ hàng`,
    ADD_NEW: `Thêm mới`,
    ADDED: `Added`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `Đã thêm vào giỏ hàng`,
    ADDON_TEXTFIELD_PLACEHOLDER: `Nhập lựa chọn của bạn`,
    ADDRESS_CITY: `Thành phố`,
    ADDRESS_LINE_1: `Địa chỉ`,
    ADDRESS_LINE_2: `Apt`,
    ADDRESS_POSTAL_CODE: `Postal code`,
    ALCOHOL_VERIFICATION: `Alcohol verification`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `Cũng có thể cân nhắc...`,
    APPLIED_STORED_VALUE_CARDS: `Thẻ quà tặng`,
    ASAP: `Càng sớm càng tốt`,
    AT_LEAST_X: `ít nhất {{$1: number}}`,
    BACK: `Quay lại`,
    BACK_TO_MENU: `Quay lại menu`,
    BACK_TO_MENU_FROM_LOYALTY: `Quay lại menu`,
    BACK_TO_CART: `Quay lại giỏ hàng`,
    BACK_TO_PAYMENT_OPTIONS: `Quay lại các hình thức thanh toán`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `Quay lại các hình thức thanh toán`,
    BAD_ACCESS_CODE: `Mã truy nhập không phù hợp`,
    BALANCE: `Số dư tài khoản`,
    BAG_OPT_IN_PROMPT: `Bạn có muốn thêm một Túi To Go vào giỏ hàng?`,
    BAG_OPT_IN_TITLE: `Bạn có cần túi đựng?`,
    BAG_OPT_IN: `Có`,
    BAG_OPT_OUT: `Không`,
    BLOCKED_WORD_WARNING: `Xin hãy loại bỏ các kí tự blocked`,
    CALORIES: `Calories`,
    CANCEL: `Hủy`,
    CANCEL_CHECKOUT: `Hủy`,
    CASH: `Tiền mặt`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `Thẻ đã lưu trên hệ thống`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `Contactless`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `Tự nhập`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `Provided externally`,
    CARD_ENTRY_SCAN: `Quét mã`,
    CARD_ENTRY_SWIPE: `Quét thẻ`,
    CARD_ENTRY_UNKNOWN: `Unknown`,
    CARD_EXPIRED: `Thẻ của bạn đã hết hạn`,
    CARD_EXPIRING: `Thẻ của bạn sắp hết hạn`,
    CART: `Giỏ hàng`,
    CART_LABEL: `Go to Cart with {{$1: number}} items for {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `Thay đổi lựa chọn`,
    CHANGE_PASSWORD: `Thay đổi mật khẩu`,
    CHANGE_PASSWORD_SUCCESS: `Mật khẩu của bạn đã được thay đổi.`,
    CHARS_LEFT: `Còn lại {{$1: number}} ký tự`,
    CHECK_AMOUNT: `Checking amount...`,
    CHECKOUT: `Thanh toán`,
    CHECKOUT_STEP_CART: `Giỏ hàng`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `Các hình thức thanh toán`,
    CHECKOUT_STEP_PAYING: `Paying`,
    CHECKOUT_STEP_DONE: `Hoàn tất`,
    CHECKOUT_WITH_FORCED_MENU: `Không thể hoàn tất thanh toán khi đang xem Menu Preview. Thanh toán chỉ có thể được hoàn tất khi xem "Currently Shown" menu.`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `Chọn một lựa chọn`,
    CHOOSE_TIME_SLOT: `Xin hãy chọn một khung giờ`,
    CLEAR_ALL: `Clear all`,
    CLEARING_SESSION: `Kiosk đang được chuẩn bị cho khách hàng tiếp theo`,
    CLOSE: `Đóng`,
    CLOSED_SCREEN_MESSAGE: `Xin lỗi quý khách`,
    CONFIRM: `Xác nhận`,
    CONFIRM_ADDRESS: `Xác nhận địa chỉ`,
    CONFIRM_DISCARD: `Bạn có muốn bỏ món hàng này?`,
    CONFIRM_DISCARD_CHANGES: `Bạn có muốn hủy những thay đổi?`,
    CONFIRM_YOUR_ITEM: `Xác nhận món hàng`,
    CONFIRM_QUIT: `Bạn có muốn dừng lại?`,
    CONFIRM_REFUND_AMOUNT: `Bạn có muốn hoàn {{$1: dollar amount}} của lần thanh toán này?`,
    CONFIRMING_YOUR_CARD: `Xác nhận giỏ hàng`,
    CONTINUE: `Tiếp tục`,
    CONTINUE_AS_GUEST: `Tiếp tục as a guest`,
    COULD_WE_INTEREST: `Bạn có muốn thử...`,
    COMP_CARD: `Comp card`,
    COMP_CARD_SCAN: `Quét comp card`,
    COMP_CARD_SCAN_FAILED_TITLE: `Quét comp card không thành công`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `Đã xảy ra lỗi khi quét comp card. Xin vui lòng thử lại.`,
    COMP_CARD_APPLYING_TITLE: `Áp dụng comp card`,
    COMP_CARD_APPLYING_ERROR_TITLE: `Comp card áp dụng không thành công`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `Đã xảy ra lỗi khi áp dụng comp card. Xin vui lòng thử lại.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Xin nhập số comp card`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `Xin vui lòng nhập số comp card hợp lệ`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Xin vui lòng nhập số comp card hợp lệ`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `Xin nhập mã PIN comp card`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `Xin vui lòng nhập mã PIN comp card hợp lệ`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `Xin vui lòng nhập mã PIN comp card hợp lệ`,
    COMP_CARD_ENTERING_NUMBER_HINT: `Hãy nhập số comp card. Mã số có thể bao gồm {{$1: number}} chữ số.`,
    COMP_CARD_ENTERING_PIN_HINT: `Hãy nhập số PIN comp card. Mã số có thể bao gồm {{$1: length}} chữ số.`,
    COMP_CARD_ERROR_REMOVING: `Đã xảy ra lỗi khi xóa comp card. Xin vui lòng thử lại.`,
    'bottom-bar.storm-toggle.on': `Chạm để bật điều hướng Storm`,
    'bottom-bar.storm-toggle.off': `Chạm để tắt điều hướng Storm`,
    'campus-card.label': `Thẻ sinh viên`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `Chạm để thanh toán bằng Thẻ sinh viên`,
    'campus-card.scan': `Quét thẻ sinh viên của bạn`,
    'campus-card.scan-failed.title': `Quét thẻ sinh viên không thành công`,
    'campus-card.scan-failed.message': `Đã xảy ra lỗi khi quét thẻ sinh viên. Xin vui lòng thử lại.`,
    'campus-card.enter-number': `Nhập số thẻ sinh viên của bạn`,
    'campus-card.enter-pin': `Nhập mã PIN thẻ sinh viên của bạn`,
    'campus-card.applying.title': `Đang áp dụng thẻ sinh viên`,
    'campus-card.applying.error.title': `Áp dụng thẻ sinh viên không thành công`,
    'campus-card.applying.error.message': `Đã xảy ra lỗi khi áp dụng thẻ sinh viên. Xin vui lòng thử lại.`,
    'campus-card.entering-number.error.required': `Xin nhập số thẻ sinh viên.`,
    'campus-card.entering-number.error.invalid': `Xin nhập số thẻ sinh viên hợp lệ.`,
    'campus-card.entering-number.error.length': `Xin nhập số thẻ sinh viên hợp lệ.`,
    'campus-card.entering-number.hint': `Nhập số thẻ sinh viên của bạn. Số thẻ có thể có {{$1: number}} chữ số.`,
    'campus-card.entering-pin.error.required': `Xin nhập mã PIN thẻ sinh viên.`,
    'campus-card.entering-pin.error.invalid': `Xin nhập mã PIN thẻ sinh viên hợp lệ.`,
    'campus-card.entering-pin.error.length': `Xin nhập mã PIN thẻ sinh viên hợp lệ.`,
    'campus-card.entering-pin.hint': `Nhập mã PIN thẻ sinh viên của bạn. Mã số có thể có {{$1: length}} chữ số.`,
    'campus-card.error-removing': `Đã xảy ra lỗi khi xóa thẻ sinh viên. Xin vui lòng thử lại.`,
    'campus-card.no-balance.title': `Không còn số dư khả dụng`,
    'campus-card.no-balance.message': `Thẻ sinh viên này không còn số dư khả dụng.`,
    'campus-card.add-another': `Thêm thẻ khác`,
    'campus-card.remove': `Xóa thẻ sinh viên`,
    'campus-card.select-account.title': `Chọn một tài khoản`,
    'campus-card.select-account.loading': `Đang tải tài khoản...`,
    'campus-card.select-account.error.title': `Không thể tải tài khoản`,
    'campus-card.select-account.error.message': `Chúng tôi không thể tải tài khoản của bạn. Xin vui lòng thử lại.`,
    'campus-card.select-account.column.account': `Tài khoản`,
    'campus-card.select-account.column.balance': `Số dư hiện tại`,
    'campus-card.select-account.error.toast-title': `Lỗi`,
    'campus-card.select-account.error.toast-message': `Xác thực không thành công. Xin vui lòng thử lại.`,
    'campus-card.swipe': `Quẹt thẻ sinh viên của bạn để thanh toán`,
    COUPON: `Coupon`,
    COUPON_ALREADY_USED: `Mã coupon đã được sử dụng.`,
    COUPON_MIN_SPEND_NOT_MET: `Mã coupon bạn nhập không đáp ứng yêu cầu chi tiêu tối thiểu.`,
    COUPON_NOT_FOUND: `Không tìm thấy mã coupon.`,
    COUPON_NOT_ACCEPTED: `Mã coupon quý khách nhập không được chấp nhận.`,
    COUPON_APPLYING: `Áp dụng coupon`,
    COUPON_APPLYING_ERROR_TITLE: `Áp dụng coupon không thành công`,
    COUPON_APPLYING_ERROR_MESSAGE: `Đã xảy ra lỗi khi áp dụng coupon. Xin vui lòng thử lại.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `Mã coupon bạn nhập không đáp ứng các yêu cầu của đơn hàng.`,
    COUPON_SCANNING_ERROR_TITLE: `Quét coupon không thành công`,
    COUPON_SCANNING_ERROR_MESSAGE: `Đã xảy ra lỗi khi quét coupon. Xin vui lòng thử lại.`,
    COUPON_ENTERING_ERROR_LENGTH: `Xin hãy nhập mã coupon.`,
    COUPON_ENTERING_ERROR_INVALID: `Xin hãy nhập mã coupon hợp lệ.`,
    COUPON_ERROR_REMOVING: `Đã xảy ra lỗi khi xóa mã coupon. Vui lòng thử lại. Quý khách có thể loe6n lạc với nhân viên nếu cần thêm trợ giúp.`,
    CREATE_A_NEW_ACCOUNT: `Tạo tài khoản mới`,
    CREATE_ACCOUNT: `Tạo tài khoản`,
    CREATE_ACCOUNT_TERMS_LINE: `Khi tạo tài khoản quý khách đồng ý với`,
    CREDIT_CARD: `Thẻ tín dụng`,
    CREDIT_CARD_NUMBER: `Số thẻ`,
    CURBSIDE: `Curbside`,
    CURRENT_PASSWORD: `Mật khẩu hiện tại`,
    CUSTOM_TIP: `Custom`,
    CUSTOM_TIP_INVALID: `Xin hãy nhập số tiền tip hợp lệ`,
    CUSTOM_TIP_HINT: `Xin nhập số tiền tip. Nhiều nhất là: {{$1: number}}`,
    CUSTOM_DONATION: `Custom`,
    CUSTOMER_CARDS: `Dùng thẻ đã lưu`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `Đăng nhập`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `Tài khoản của bạn`,
    CUSTOMIZE: `Tùy chọn`,
    DEBIT: `Debit`,
    DEBIT_CREDIT_CARD: `Debit/Credit card`,
    DEMO_PAY: `Demo: Thanh toán`,
    DELIVERY: `Giao hàng`,
    DELIVERY_ADDRESS: `Địa chỉ giao hàng`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `Remove {{$1: mod name}}`,
    DINE_IN: `Dùng bữa tại quán`,
    DISCLAIMER_EMAIL: `Việc sử dụng email phụ thuộc vào yêu cầu của dịch vụ.`,
    DISCLAIMER_PHONE: `Việc sử dụng số điện thoại phụ thuộc vào yêu cầu của dịch vụ.`,
    DISCLAIMER_PHONE_LINK: `TERMS OF SERVICE:`,
    DISCLAIMER_PHONE_DESCRIPTION: `FOR USE OF PHONE NUMBER`,
    DISCLAIMER_NAME: `Tên của quý khách sẽ được dùng để xác nhận đơn hàng và khi quý khách nhận đơn hàng tại địa điểm nhận hàng.`,
    DISCOUNTS: `Giảm giá`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `Giảm giá sẻ được áp dụng khi thanh toán`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `Giảm giá sẻ được áp dụng khi thanh toán`,
    DONATION: `Quyên góp`,
    DONATION_APPLYING: `Đang áp dụng khoản quyên góp...`,
    DONATION_APPLY_ERROR_TITLE: `Áp dụng khoản quyên góp không thành công`,
    DONATION_APPLY_ERROR_MESSAGE: `Đã xảy ra lỗi khi áp dụng khoản quyên góp của bạn. Xin vui lòng thử lại.`,
    DONATION_FAILED: `Quyên góp không thành công. Xin vui lòng thử lại.`,
    DONATION_ROUND_UP_TITLE: `Bạn có muốn làm tròn tổng tiền của mình không?`,
    DONATION_ROUND_UP_TO: `Làm tròn lên {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `Bạn có muốn làm tròn tổng tiền của mình lên đến số đô la nguyên gần nhất không?`,
    DONATION_ROUND_UP_ACCEPT: `Có, làm tròn lên`,
    DONATION_ROUND_UP_REJECT: `Không, cảm ơn`,
    DONATION_REMOVE: `Xóa khoản quyên góp`,
    DONE: `Hoàn tất`,
    DONT_INCLUDE_UTENSILS: `Không bao gồm dụng cụ ăn uống`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `Hoàn tiền EBT`,
    EBT_CHOICE_DIALOG_TITLE: `Bạn muốn sử dụng phương thức EBT nào?`,
    EBT_CHOICE_CASH_BENEFIT: `Cash Benefit`,
    EBT_CHOICE_FOOD_STAMPS: `Food Stamp`,
    EBT_CARD_SUBTITLE: `Quẹt thẻ EBT của bạn trên máy thẻ tín dụng`,
    EDIT: `Thay đổi`,
    EDIT_ORDER: `Thay đổi đơn hàng`,
    EDIT_TIP: `Thay đổi tip`,
    SAVE_ORDER: `Lưu đơn hàng`,
    EMAIL_ADDRESS: `Địa chỉ email`,
    EMAIL_RECEIPT: `Email hóa đơn`,
    EMAIL_REQUIRED_FOR_RECEIPT: `Địa chỉ email là bắt buộc cho hóa đơn của bạn.`,
    EMAIL_RECEIPT_SEND_FAILED: `Không thể gửi hóa đơn. Xin vui lòng thử lại.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `Hóa đơn đã được gửi thành công.`,
    ENTER_ACCESS_CODE: `Nhập mã đăng nhập:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `Nhập email của bạn`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `Quét mã không thành công? Hãy nhập số thẻ của bạn`,
    ENTER_PHONE_CONSENT: `Quý khách đồng ý nhận thông tin quảng cáo qua SMS.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `Nhập số điện thoại của bạn`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `Xin chào {{$1 guest name}}, hãy nhập số điện thoại của bạn`,
    ENTER_PHONE_LOYALTY: `Xin nhập số điện thoại của bạn`,
    ENTER_PHONE_RECEIPT: `Xin nhập số điện thoại của bạn để nhận hóa đơn`,
    ENTER_PHONE_TEXT_WHEN_READY: `Xin nhập số điện thoại của bạn để nhận thông báo qua tin nhắn khi đơn hàng của bạn hoàn tất!`,
    ENTER_VEHICLE_DESCRIPTION: `Xin hãy nhập thông tin xe của bạn để chúng tôi có thể giao đơn hàng cho bạn:`,
    ENTER_YOUR_COUPON_CODE: `Nhập mã coupon của bạn`,
    ENTER_YOUR_COMP_CARD_NUMBER: `Nhập số comp card của bạn`,
    ENTER_YOUR_COMP_CARD_PIN: `Nhập mã PIN comp card của bạn`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `Nhập số thẻ quà tặng của bạn`,
    ENTER_YOUR_GIFT_CARD_PIN: `Nhập mã PIN thẻ quà tặng của bạn`,
    ENTER_YOUR_EMAIL: `Nhập email của bạn`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `Email không hợp lệ. Xin vui lòng thử lại.`,
    ENTER_YOUR_FIRST_NAME: `Nhập tên của bạn:`,
    ENTER_YOUR_LAST_NAME: `Nhập chữ cái đầu của họ của bạn:`,
    ENTER_YOUR_NAME: `Nhập tên của bạn:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `Tên không hợp lệ. Xin vui lòng thử lại.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `Hãy nhập một cái tên`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `Vui lòng chỉ nhập một chữ cái. Xin hãy thử lại.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `Tên chỉ có thể bao gồm chữ cái. Xin vui lòng thử lại.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `Tên bao gồm ngôn ngữ không hợp lệ. Xin vui lòng thử lại.`,
    ERROR: `Oops!`,
    ERROR_ADDING_ITEM: `Đã xảy ra lỗi khi thêm món hàng vào giỏ hàng. Xin vui lòng thử lại. Quý khách có thể hỏi nhân viên nếu cần thêm sự trợ giúp.`,
    ERROR_EDITING_ITEM: `Đã xảy ra lỗi khi thay đổi món hàng trong giỏ hàng. Xin vui lòng thử lại. Quý khách có thể hỏi nhân viên nếu cần thêm sự trợ giúp.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `Số tiền vượt quá số dư trong thẻ.`,
    ERROR_CARD_CONFIRMATION: `Xin lỗi quý khách`,
    ERROR_CARD_DECLINED: `Không thể hoàn tất thanh toán bằng thẻ đã chọn. Xin vui lòng thử lại.`,
    ERROR_CARD_INACTIVE: `Xin lỗi quý khách`,
    ERROR_CARD_NOT_FOUND: `Xin lỗi quý khách`,
    ERROR_CARD_NUMBER_LENGTH: `Số thẻ không đúng với độ dài yêu cầu.`,
    ERROR_CARD_RESTRICTED_TIME: `Xin lỗi quý khách`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `Xin lỗi quý khách, {{$1: cardScheme}} không được chấp nhận tại đây. Quý khách vui lòng thử thẻ khác.`,
    ERROR_COUPON_CONFIRMATION: `Xin lỗi quý khách! Mã coupon này không thể được sử dụng. Xin vui lòng thử lại.`,
    ERROR_INVALID_EMAIL: `Địa chỉ email không hợp lệ`,
    ERROR_INVALID_LOGIN_CREDS: `Tên người dùng / mật khẩu không hợp lệ`,
    ERROR_INVALID_NAME: `Xin hãy nhập tên hợp lệ`,
    ERROR_INVALID_PHONE_NUMBER: `Xin hãy nhập số điện thoại hợp lệ`,
    ERROR_INVALID_ROOM_NUMBER: `Xin hãy nhập số phòng hợp lệ`,
    ERROR_INVALID_TABLE_NUMBER: `Xin hãy nhập số bàn hợp lệ`,
    ERROR_INVALID_VERIFICATION_CODE: `Mã verification không hợp lệ`,
    ERROR_KIOSK_CARD_DECLINED: `Đã có lỗi xảy ra. Thẻ của bạn chưa bị charged. Xin vui lòng thử lại.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `Tap không thành công. Xin vui lòng thử lại.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `Kiosk này không thể kết nối với máy thanh toán. Thẻ của bạn chưa bị charged. Xin vui lòng liên lạc với nhân viên.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `Máy thanh toán hiện đang offline. Thẻ của bạn chưa bị charged. Xin vui lòng liên lạc với nhân viên.`,
    ERROR_ORDER_OPERATION: `Xin lỗi quý khách`,
    ERROR_PIN_LENGTH: `Mã PIN không đúng độ dài yêu cầu.`,
    ERROR_RECEIVING_PAYMENT: `Máy thanh toán không thể hoàn tất thanh toán. Xin vui lòng thử lại.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `Thanh toán chưa hoàn tất. Đơn hàng của bạn chưa hoàn tất. Hóa đơn sẽ tóm tắt đơn hàng của bạn. Vui lòng liên hệ với nhân viên để được trợ giúp thêm.`,
    ERROR_SENDING_ORDER: `Xin chào`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `Thanh toán thành công`,
    ERROR_STARTING_ORDER: `Xin lỗi quý khách`,
    ERROR_UPDATING_ORDER: `Xin lỗi, chúng tôi không thể cập nhật đơn hàng của bạn. Xin vui lòng thử lại. Nếu sự cố vẫn tiếp diễn, vui lòng liên hệ với nhân viên.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `Bạn không thể xem món hàng này. Bạn đã đạt mức độ cồn cho phép cho đơn hàng. Bạn có thể bỏ bớt một món hàng chứa cồn khác để thêm món hàng này.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `Bạn không thể xem món hàng này. Bạn đã đạt mức tối đa cho ưu đãi đặc biệt. Bạn có thể bỏ bớt một ưu đãi khác để thêm ưu đãi này.`,
    EXIT: `Thoát`,
    EXIT_CONFIRMATION: `Bạn có chắc chắn muốn thoát? Thoát sẽ xóa đơn hàng của bạn.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `Yêu thích`,
    FAVORITES: `Yêu thích`,
    FAVORITES_NONE_YET: `Không có yêu thích nào`,
    FAVORITES_REMOVE_CONFIRMATION: `Bạn có chắc chắn muốn xóa mục yêu thích này?`,
    FETCHING_RECOMMENDATIONS: `Tải gợi ý...`,
    FIND_ACCOUNT: `Tìm tài khoản`,
    FIRST_NAME: `Tên riêng`,
    FORGOT_PASSWORD: `Quên mật khẩu?`,
    FULFILLMENT_LABEL_ADDRESS: `Địa chỉ`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `Email`,
    FULFILLMENT_LABEL_GUEST_NAME: `Dành cho`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `Mã đơn hàng`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `Số bàn`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `Số điện thoại`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `Tracker number`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `Đặc điểm của xe`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `Đơn hàng của bạn sẽ được giao đến địa chỉ bên dưới.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `Chúng tôi sẽ gửi hóa đơn cho bạn.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `Chúng tôi sẽ gọi tên khi đơn hàng của bạn hoàn tất.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `Mã đơn hàng của bạn sẽ được gọi.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `Bạn sẽ nhận được tin nhắn thông báo khi đơn hàng hoàn tất.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `Chúng tôi sẽ phục vụ tại bàn cho quý khách.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `Máy tracker sẽ kêu khi đơn hàng hoàn tất.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `Đồ ăn sẽ được mang ra ngoài cho quý khách khi bạn tới nơi.`,
    FULFILLMENT_TOGGLE: `Toggle active fulfillment method`,
    FULL_NAME: `Họ tên`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `Xin lỗi`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `Xin lỗi`,
    FUTURE_ORDER_SET_FOR: `Đơn hàng dành cho:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `Xin lỗi quý khách! Khung giờ quý khách lựa chọn không khả dụng. Vui lòng chọn khung giờ khác.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `Đã xảy ra lỗi khi tải các khung giờ khả dụng. Xin vui lòng thử lại. Nếu sự cố vẫn tiếp diễn, vui lòng liên hệ với nhân viên.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `Xin hãy chọn một khung giờ.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `Khung giờ`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `Hôm nay`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `Ngày mai`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `Nhận hàng hôm nay lúc {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `Nhận hàng vào ngày làm việc tiếp theo lúc {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `Thời gian chuẩn bị đơn hàng ước tính: {{$1: time}}`,
    GENERIC_ERROR: `Oops! Đã xảy ra lỗi! Xin vui lòng thử lại. Quý khách có thể liên hệ nhân viên để được trợ giúp thêm.`,
    GET_REWARDS: `Nhận phần thưởng`,
    GET_RECEIPT: `Nhận hóa đơn`,
    GET_RECEIPT_DIALOG_TITLE: `Tùy chọn hóa đơn`,
    GIFT_CARD: `Thẻ quà tặng`,
    GIFT_CARD_SECONDARY: `Thẻ quà tặng thay thế`,
    GIFT_CARD_TITLE: `Thanh toán bây giờ`,
    GIFT_CARD_SUBTITLE: `Thanh toán bằng thiết bị thẻ tín dụng bằng cách quẹt thẻ quà tặng của bạn.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `Không thể quét thẻ quà tặng`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `Chúng tôi không thể quét thẻ quà tặng của bạn. Xin vui lòng thử lại.`,
    GIFT_CARD_APPLYING_TITLE: `Áp dụng thẻ quà tặng`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `Thẻ quà tặng không thể được áp dụng`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `Chúng tôi không thể áp dụng thẻ quà tặng của bạn. Xin vui lòng thử lại.`,
    GIFT_CARD_NO_BALANCE_TITLE: `Số dư thẻ quà tặng không đủ`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `Thẻ quà tặng của bạn không còn số dư`,
    GIFT_CARD_ADD_ANOTHER: `Add another`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Xin nhập số thẻ quà tặng.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `Xin nhập số thẻ quà tặng hợp lệ.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Xin nhập số thẻ quà tặng hợp lệ.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `Xin nhập mã PIN`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `Xin nhập mã PIN hợp lệ.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `Xin nhập mã PIN hợp lệ.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `Xin nhập số thẻ quà tặng. Số thẻ có thể có {{$1: length}} chữ số.`,
    GIFT_CARD_ENTERING_PIN_HINT: `Xin nhập mã PIN. Mã PIN có thể có {{$1: length}} chữ số.`,
    GIFT_CARD_ERROR_REMOVING: `Lỗi khi xóa thẻ quà tặng. Vui lòng thử lại. Quý khách có thể liên hệ nhân viên để được trợ giúp thêm.`,
    'gift-card.select-account.title': `Chọn một tài khoản`,
    'gift-card.select-account.loading': `Đang tải tài khoản...`,
    'gift-card.select-account.error.title': `Không thể tải tài khoản`,
    'gift-card.select-account.error.message': `Chúng tôi không thể tải tài khoản của bạn. Xin vui lòng thử lại.`,
    'gift-card.select-account.column.account': `Tài khoản`,
    'gift-card.select-account.column.balance': `Số dư hiện tại`,
    'gift-card.select-account.error.toast-title': `Lỗi`,
    'gift-card.select-account.error.toast-message': `Xác thực không thành công. Xin vui lòng thử lại.`,
    GLOSSARY_TERM_LEARN_MORE: `Tìm hiểu thêm`,
    GOES_WELL_WITH: `Ngon hơn khi dùng với`,
    GRAND_TOTAL: `Tổng tiền`,
    GROUP_ORDERING_ADD_GUEST: `Thêm khách`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `Tên khách chứa ký tự không hợp lệ.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `Tên khách đã được sử dụng. Xin hãy nhập một tên khác.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `Khách {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `Đặt hàng nhóm - Món hàng này dành cho ai`,
    GROUP_ORDERING_LABEL: `Đặt hàng nhóm - Món hàng dành cho:`,
    GROUP_ORDERING_TITLE: `Đặt hàng nhóm`,
    GROUP_ORDERING_SUBTITLE: `Tùy chọn đặt hàng nhóm sẽ hỏi bạn mỗi món hàng dành cho thành viên nào trong nhóm của bạn. Chạm “Có” để bật đặt hàng nhóm. Chạm “Không” nếu bạn muốn tiếp tục.`,
    GUEST_INFO: `Thông tin khách hàng`,
    GUEST_RATING_LABEL_0: `Nhấn để đánh giá với 0: Rất không hài lòng.`,
    GUEST_RATING_LABEL_1: `Nhấn để đánh giá với 1: Hơi không hài lòng.`,
    GUEST_RATING_LABEL_2: `Nhấn để đánh giá với 2: Hơi hài lòng.`,
    GUEST_RATING_LABEL_3: `Nhấn để đánh giá với 3: Rất hài lòng.`,
    GUEST_RATING_0: `Cám ơn đóng góp của quý khách!`,
    GUEST_RATING_1: `Cám ơn đóng góp của quý khách!`,
    GUEST_RATING_2: `Cám ơn đóng góp của quý khách!`,
    GUEST_RATING_3: `Cám ơn đóng góp của quý khách!`,
    GUEST_RATING_SUBMITTED: `Cám ơn đóng góp của quý khách!`,
    HIDE: `Ẩn`,
    HOME: `Trang chủ`,
    HOW_DID_WE_DO: `Chúng tôi đã làm như thế nào? Hãy đánh giá chúng tôi!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `Bạn muốn dùng hình thức thanh toán nào?`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `Bạn muốn đơn hàng của mình như thế nào?`,
    KITCHEN_CLOSED: `Xin lỗi quý khách`,
    ID_CHECK_LABEL: `Đơn hàng của bạn có chứa cồn. Bạn có thể sẽ được yêu cầu xuất trình chứng minh nhân dân.`,
    ID_CHECK_CODE_MESSAGE: `Cần mã truy cập của nhân viên để thanh toán với rượu. Vui lòng yêu cầu sự trợ giúp từ nhân viên.`,
    IE_WARNING: `Chúng tôi nhận thấy bạn đang truy cập trang web của chúng tôi từ Internet Explorer. Để có trải nghiệm tốt nhất`,
    INCLUDE_UTENSILS: `Bao gồm dụng cụ ăn uống.`,
    ITEM_86D: `Xin chào`,
    ITEM_86D_VALIDATION: `Xin chào`,
    ITEM_RECIPIENT: `Dành cho`,
    ITEM_RECIPIENT_FOR: `Dành cho {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `Gợi ý`,
    ITEM_STEP_TITLE: `Bước {{$1: step}}`,
    ITEM_STEP_EMPTY: `Không có sự lựa chọn nào được thực hiện trong bước này.`,
    ITEM_STEP_NO_RECOS: `Không có gợi ý nào`,
    ITEMS_NO_LONGER_IN_MENU: `Một số món đã được xóa khỏi giỏ hàng của bạn vì không còn trong thực đơn.`,
    ITEM_SCAN_ERROR: `Chúng tôi không tìm thấy món hàng này. Vui lòng thêm món từ menu hoặc hỏi nhân viên để được trợ giúp.`,
    ITEM_SCAN_SUCCESS: `Món đã được thêm vào giỏ hàng!`,
    LAST_NAME: `Họ`,
    LEAD_TIME_LONG: `Đơn hàng của bạn có thể cần nhiều thời gian hơn so với khung giờ bạn đã chọn.`,
    LEAD_TIME_CART: `Đơn hàng này có thể mất thời gian chuẩn bị lâu hơn so với thời gian lấy hàng bạn yêu cầu do một số món đã chọn.`,
    LANGUAGE_SELECT_LABEL: `Chạm để chọn ngôn ngữ`,
    LOADING: `Đang tải...`,
    LOADING_MENU: `Đang tải menu...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `Tìm kiếm cửa hàng`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `Tìm kiếm cửa hàng cho {{$1: dine-in/take-away}}`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `Bạn muốn đơn hàng của mình như thế nào?`,
    LOCATION_SEARCH_HEADER: `Chào mừng đến với {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Địa chỉ`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `Đăng nhập`,
    LOGIN: `Đăng nhập`,
    LOGIN_GIFT_CARD: `Đăng nhập bằng thẻ quà tặng`,
    LOGIN_GIFT_CARD_SECONDARY: `Đăng nhập bằng thẻ quà tặng thay thế`,
    LOGIN_WALL_WELCOME: `Xin chào!`,
    LOGIN_WALL_WELCOME_USER: `Xin chào, {{$1: user}}!`,
    LOGIN_WITH_CARD_NUMBER: `Đăng nhập bằng số thẻ`,
    LOGIN_WITH_PHONE: `Đăng nhập bằng điện thoại`,
    LOOKING_UP_ACCOUNT: `Đang tìm kiếm tài khoản...`,
    LOOKUP_CARD: `Đang tìm kiếm thẻ...`,
    LOOKUP_COUPON: `Đang tìm kiếm coupon...`,
    LOYALTY: `Điểm thưởng`,
    LOYALTY_ACCOUNT_APPLY: `Áp dụng`,
    LOYALTY_CARD_NUMBER: `Số thẻ`,
    LOYALTY_EXIT_TO_MENU: `Đến menu`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `Quét mã App QR`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `Không có app? Xin nhập số điện thoại của bạn`,
    LOYALTY_AUTH_METHOD_BARCODE: `Quét mã App QR`,
    LOYALTY_AUTH_METHOD_HID: `Chạm thẻ HID`,
    LOYALTY_AUTH_METHOD_PHONE: `Nhập số điện thoại của bạn`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `Nhập số thẻ của bạn`,
    LOYALTY_AUTH_METHOD_EMAIL: `Nhập email của bạn`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `Nhập email và mật khẩu của bạn`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `Nhập email và số điện thoại của bạn`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `Nhập tên đăng nhập và mật khẩu của bạn`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `Nhập số điện thoại của tài khoản của bạn`,
    LOYALTY_APP_AUTH_SUBTITLE: `Để tìm thấy mã vạch`,
    LOYALTY_APP_AUTH_TITLE: `Quét mã vạch App payment của bạn bằng máy quét bên dưới.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `Nhập 7 chữ số của mã điểm thưởng`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `Nhập 7 chữ số của mã điểm thưởng`,
    LOYALTY_APPLY_REWARD_FAILED: `Không thể áp dụng điểm thưởng. Xin vui lòng thử lại.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `Không thể áp dụng điểm thưởng sau {{$1: reward name}} . Xin vui lòng thử lại.`,
    LOYALTY_APPLYING_REWARD: `Áp dụng điểm thưởng...`,
    LOYALTY_AUTH_GENERIC_ERROR: `Xin lỗi chúng tôi không thể tìm thấy tài khoản điểm thưởng này. Xin vui lòng thử lại.`,
    LOYALTY_AUTH_INSTRUCTIONS: `Đăng nhập để thu thập và sử dụng điểm thưởng trong Reward program của bạn.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `Điểm thưởng hiện tại`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `Số dư hiện tại`,
    LOYALTY_CANNOT_MODIFY_REWARD: `Xin lỗi - bạn không thể chỉnh sửa điểm thưởng sau khi đã thanh toán cho đơn hàng.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `Xin lỗi`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `Nhập số thẻ của bạn để thu thập và sử dụng điểm thưởng trong Reward program của bạn.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `Xin lỗi - bạn không thể sử dụng điểm thưởng của mình vì một mã coupon đã được áp dụng.`,
    LOYALTY_GETTING_REWARDS: `Đang lấy điểm thưởng của bạn...`,
    LOYALTY_FETCH_REWARDS_FAILED: `Không thể lấy điểm thưởng. Xin vui lòng thử lại.`,
    LOYALTY_REWARD_APPLY: `Áp dụng`,
    LOYALTY_REWARD_APPLY_FAILED: `Không thể áp dụng điểm thưởng. Một số điểm thưởng không thể áp dụng cho đơn hàng của bạn.`,
    LOYALTY_REWARD_APPLIED: `Đã áp dụng`,
    LOYALTY_REWARD_INVALID: `Không hợp lệ`,
    LOYALTY_REWARD_LABEL_MEAL: `Bữa ăn`,
    LOYALTY_REWARD_LABEL_MEALS: `Bữa ăn`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `Đổi ngay`,
    LOYALTY_REWARD_LABEL_SELECTED: `Đã chọn`,
    LOYALTY_REWARD_LABEL_APPLIED: `Đã đổi`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `Đổi khi thanh toán`,
    LOYALTY_REWARD_LABEL_REMOVING: `Đang xóa`,
    LOYALTY_REWARD_LABEL_ERROR: `Lỗi khi áp dụng`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `Không áp dụng được`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `Điểm thưởng`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `Điểm thưởng theo phần trăm`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `Điểm thưởng cố định`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `Điểm thưởng ví`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `Điểm thưởng ví và thanh toán`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `Điểm thưởng món miễn phí`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `Điểm thưởng đổi bữa ăn`,
    LOYALTY_REWARDS_FOR: `cho`,
    LOYALTY_NO_REWARDS_LABEL: `Không có điểm thưởng`,
    LOYALTY_NO_REWARDS_NO_EARNING: `Không có điểm thưởng khả dụng cho các món hàng này.`,
    LOYALTY_NO_REWARDS_TEXT: `Không có điểm thưởng khả dụng cho các món hàng này`,
    LOYALTY_PAYMENT: `Với điểm thưởng`,
    LOYALTY_PAYMENT_CARD_CHARGED: `{{$1: charge_amount}} sẽ được tính vào thẻ đã lưu trên hệ thống.`,
    LOYALTY_PAYMENT_FAILED: `Không thể áp dụng thanh toán.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `Đã xảy ra sự cố khi xử lý thanh toán bằng điểm thưởng. Xin vui lòng thử lại hoặc chọn phương thức thanh toán khác.`,
    USE_LOYALTY_PAYMENT: `Dùng điểm thưởng`,
    LOYALTY_PAYMENT_SUBMIT: `Thực hiện thanh toán`,
    LOYALTY_PAYMENT_REWARD: `Tính vào điểm thưởng`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `Thẻ đã lưu với nhà cung cấp của bạn sẽ được tính phí cho giao dịch này.`,
    LOYALTY_PAY_WITH_APP: `Thanh toán bằng app`,
    LOYALTY_EARNED_POINT_ESTIMATE: `Điểm thưởng ước tính cho đơn hàng này:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number}} điểm`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `Tình trạng tài khoản`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `Chúng tôi không thể tìm thấy tài khoản của bạn.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `Hãy đăng nhập vào tài khoản bên dưới của bạn để thu thập và sử dụng điểm thưởng.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `Đăng ký bằng số điện thoại`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `Bạn vẫn có thể thu thập điểm cho đơn hàng hôm nay bằng cách quét hóa đơn sau khi đăng nhập.`,
    LOYALTY_INTRO_QR_SIGN_IN: `Hãy quét mã QR bên dưới để đăng nhập.`,
    LOYALTY_INTRO_QR_SIGN_UP: `Hãy quét mã QR bên dưới để đăng ký.`,
    LOYALTY_INTRO_WELCOME_BACK: `Chào mừng`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `Số điện thoại bạn cung cấp liên kết với nhiều tài khoản khách hàng thân thiết hoặc không tồn tại.`,
    LOYALTY_REDEMPTION_CODE: `Áp dụng mã redemption`,
    LOYALTY_REMOVING_REWARD: `Xóa điểm thưởng`,
    LOYALTY_SCAN_FAILED_TITLE: `Quét không thành công`,
    LOYALTY_SCAN_FAILED_MESSAGE: `Chúng tôi không thể quét mã QR của bạn. Xin hãy thử lại.`,
    LOYALTY_SIGN_OUT_NOTICE: `Bạn sẽ tự động đăng xuất khi đơn hàng được đặt hoặc khi bạn thoát khỏi menu.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `Bạn sẽ tự động đăng xuất khi đơn hàng được đặt hoặc khi bạn thoát khỏi menu. Mật khẩu sẽ không bao giờ được lưu.`,
    LOYALTY_SIGN_UP_SMS_SENT: `Tin nhắn đăng ký đã được gửi!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `Quay lại mục đăng nhập`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `Đăng ký thành công!`,
    LOYALTY_SIGN_UP_WITH_QR: `Đăng ký bằng mã QR`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `Đăng ký bằng số điện thoại`,
    LOYALTY_WELCOME_TITLE: `Thu thập và sử dụng điểm thưởng`,
    LOYALTY_SIGNUP_TITLE: `Nhận link đăng ký qua điện thoại của bạn.`,
    LOYALTY_YOU_CURRENTLY_HAVE: `Hiện tại bạn có`,
    LOYALTY_NAV_REWARDS: `Điểm thưởng của tôi`,
    LOYALTY_NAV_ORDER_HISTORY: `Đơn hàng của tôi`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `Bạn đã vượt quá số lần đăng nhập tối đa.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `Bạn đã vượt quá số lần truy cập thẻ quà tặng tối đa.`,
    MAKE_IT_A_COMBO: `Bạn có muốn làm thành combo không?`,
    MAKE_IT_A_COMBO_MOD: `Bạn có muốn làm thành combo không?`,
    MAKE_IT_A_COMBO_ACCEPT: `Có!`,
    MAKE_IT_A_COMBO_REJECT: `Không`,
    MAKE_IT_A_COMBO_NO: `Không`,
    MAKE_IT_A_COMBO_YES: `Bạn có muốn làm thành combo không?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `Lựa chọn tuyệt vời!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `Hãy chọn món ăn kèm và đồ uống bên dưới!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `Thêm món ăn kèm và đồ uống để làm thành combo!`,
    MENU_COVER_ALT_TEXT: `Nhấn vào đây để bắt đầu đơn hàng`,
    MENU_COVER_LOYALTY_TEXT: `Đăng nhập điểm thưởng để tích điểm và đổi phần thưởng.`,
    MENU_COVER_QUIZ_TEXT: `Làm bài trắc nghiệm để tìm ra món phù hợp với bạn!`,
    MENU_COVER_WAYFINDER_TEXT: `Đến bản đồ chỉ đường của chúng tôi để tìm lối đi`,
    MAINTENANCE_COVER_TITLE: `Kiosk này đang được bảo trì`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo HID đã được kết nối với kiosk.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID bị gián đoạn`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo KDS đã được kết nối với kiosk.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS bị gián đoạn`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `Xin hãy thử một kiosk khác hoặc nhờ nhân viên giúp đỡ.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `Kiosk này hiện không khả dụng`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo Đầu đọc thẻ từ đã được kết nối với kiosk.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `Đầu đọc thẻ từ bị gián đoạn`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo kiosk đã được kết nối với mạng.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `Không có kết nối mạng`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `Kiosk này đang gặp sự cố kết nối do tốc độ internet thấp.\n\nXin hãy kiểm tra kết nối của bạn có ổn định không.\n\nTốc độ khuyến nghị: Tối thiểu 10 Mbps tải lên và tải xuống.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `Phát hiện mạng không ổn định`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo thiết bị thanh toán đã được bật và kết nối với kiosk.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `Thiết bị thanh toán bị gián đoạn`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `Xin hãy đảm bảo nắp máy in đã được đóng.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `Nắp máy in đang mở`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo máy in đã được kết nối với kiosk.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `Máy in bị gián đoạn`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `Xin hãy đảm bảo máy in có giấy.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `Máy in hết giấy`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo cân đã được kết nối với kiosk.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `Cân bị gián đoạn`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `Xin hãy đảm bảo máy quét đã được kết nối với kiosk.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `Máy quét bị gián đoạn`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `Giới hạn tối đa đồ uống có cồn cho mỗi đơn hàng là {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `Giới hạn tối đa cho món đặc biệt trong mỗi đơn hàng là {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `Bạn thích đơn hàng của bạn thế nào?`,
    MENU_COVER_LANGUAGE_OPTIONS: `Chọn ngôn ngữ để bắt đầu`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `Nhấn vào đây để bắt đầu đặt hàng và xem món được khuyến mãi này: {{$1: item name}}`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `Nhấn vào đây để bắt đầu đặt hàng và đi thẳng đến mục khuyến mãi này: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `Nhấn vào đây để bắt đầu đặt hàng và chuyển thẳng đến trang khuyến mãi này: {{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `Nhấn vào đây để bắt đầu đặt hàng cho "{{$1: fulfillment method}}"!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `Quay lại các lựa chọn dining`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `Quay lại số điện thoại`,
    MARKETING_CONSENT: `Tôi muốn nhận thông tin`,
    MENU_FILTERS_DIETARY_FILTERS: `Chế độ ăn uống`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `Để lựa chọn món ăn lành mạnh hơn`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `Tùy chọn dinh dưỡng`,
    MENU_FILTERS_OTHER_FILTERS: `Other`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `Restrictive`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `Nếu bạn bị dị ứng`,
    MENU_FILTERS_COUNT: `{{$1: number}} Tùy chọn Dinh Dưỡng đã được kích hoạt. Nhấn để chỉnh sửa.`,
    MOD_86D: `Chào bạn`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} món hàng tổng cộng`,
    MOD_GROUP_CHOICES_INCREMENT: `multiples of {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `Chọn một lựa chọn`,
    MOD_GROUP_CHOICES_MAKE_X: `Chọn {{$1: number range, e.g. 2-3}} lựa chọn khác nhau`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} mỗi lựa chọn`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `Chọn ít nhất {{$1: number range}}`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `Chọn giữa  {{$1: number}} và {{$2: number}}`,
    MOD_GROUP_CHOOSE_ONE: `Chọn một`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `Chọn nhiều nhất một lựa chọn`,
    MOD_GROUP_CHOOSE_UP_TO_X: `Chọn nhiều nhất {{$1: number}} lựa chọn`,
    MOD_GROUP_CHOOSE_X: `Chọn {{$1: number}} `,
    MOD_GROUP_DEEMPHASIZE_SHOW: `Hiện - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `Ẩn - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `{{$1: dollar amount}} để dùng trước khi bị tính phí.`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `Lựa chọn thêm là {{$1: dollar amount}} cho một lựa chọn`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `{{$1: number}} đầu tiên là miễn phí.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `Lựa chọn đầu tiên là miễn phí.`,
    MOD_GROUP_WALLET_UP_TO_X: `Nhiều nhất là {{$1: number}} với giá {{$2: dollar amount}} mỗi lựa chọn `,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `Đóng phần thay thế`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `Thay đổi phần thay thế`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `Thay thế`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `Thêm vào món hàng`,
    MOD_RECOMMENDED_BADGE: `Gợi ý`,
    MOD_UPSELL_PROMPT_TITLE: `Thêm lựa chọn?`,
    MOD_UPSELL_PROMPT_ACCEPT: `Thêm`,
    MOD_UPSELL_PROMPT_DECLINE: `Không, cảm ơn`,
    MODIFY: `Chỉnh sửa`,
    MODIFY_INGREDIENTS: `Chỉnh sửa các thành phần`,
    MORE: `thêm`,
    NAME_CALLED_ORDER_READY: `Chúng tôi sẽ gọi tên khi đơn hàng của bạn hoàn tất.`,
    NAME_ON_CARD: `Tên trên thẻ`,
    NEED_MORE_TIME: `Bạn cần thêm thời gian?`,
    NEW_PASSWORD: `Mật khẩu mới`,
    NEXT: `Tiếp tục`,
    NO: `Không`,
    NO_ITEMS_MATCH_FILTERS: `Không có món nào phù hợp với bộ lọc của bạn.`,
    NO_ORDERS_MATCH: `Không có đơn hàng nào phù hợp với từ khóa tìm kiếm của bạn.`,
    NO_THANKS: `Không`,
    NO_TIP: `Không tip`,
    NOT_A_MEMBER: `Không phải là thành viên?`,
    NUTRITION_INFO_CALORIES: `Cals`,
    NUTRITION_INFO_PROTEIN: `Protein`,
    NUTRITION_INFO_FAT: `Chất béo`,
    NUTRITION_INFO_CARBS: `Tinh bột`,
    NUTRITION_INFO_SUGAR: `Đường`,
    OK: `Ok`,
    OR: `hoặc`,
    OPT_OUT_OF_RECOMMENDATIONS: `Không chọn gợi ý`,
    ORDER_GET_ERROR: `Xin lỗi`,
    ORDER_HISTORY: `Lịch sử đặt hàng`,
    ORDER_HISTORY_EMPTY: `Không có đơn hàng nào trong lịch sử của bạn. Sau khi bạn đặt hàng, đơn hàng sẽ hiển thị ở đây.`,
    ORDER_HISTORY_ERROR: `Xin lỗi, chúng tôi gặp sự cố khi tải lịch sử đơn hàng của bạn. Xin vui lòng thử lại.`,
    ORDER_SENT: `Đơn hàng đã gửi`,
    ORDER_SUMMARY: `Tóm tắt đơn hàng`,
    ORDER_SUMMARY_WITH_NAME: `Tóm tắt đơn hàng cho {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho bàn {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho tracker #{{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho {{$2 guest name}} tại bàn {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho {{$2 guest name}} cho tracker #{{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho đơn hàng số #{{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho tracker #{{$2: tracker number}} cho đơn hàng số #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho bàn {{$2: table number}} cho đơn hàng số #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho {{$2 guest name}} cho đơn hàng số #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho {{$2 guest name}} tại bàn {{$3: table number}} cho đơn hàng số #{{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `Tóm tắt đơn hàng. {{$1 fulfillment}} đơn cho {{$2 guest name}} cho TRACKER {{$3: tracker number}}cho đơn hàng số #{{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `Xin lỗi quý khách! Nhà hàng đang bị quá tải. Quý khách vui lòng thử lại sau.`,
    ORDER_TIME_ASAP: `Đặt hàng NGAY LÚC NÀY`,
    ORDER_TIME_LATER: `Để sau`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `Ngày làm việc tiếp theo`,
    ORDER_TIME_FUTURE: `Đặt hàng cho lúc sau`,
    ORDER_TOTAL_MAX_EXCEEDED: `Với đơn hàng lớn`,
    ORDER_UPDATE_FAILED: `Không thể cập nhật đơn hàng.`,
    ORDER_VALIDATION_IN_PROGRESS: `Đang xác thực đơn hàng của bạn`,
    ORDER_VALIDATION_FAILED: `Oops! Đã có lỗi xảy ra!`,
    ORDER_WAS_PLACED: `Đơn hàng của bạn đã được đặt`,
    ORDERING_MODE_CHANGED: `Chế độ đặt hàng đã thay đổi. Session của bạn đã được tải lại.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `Nhấn vào đây để làm {{$1: ordered item name}} thành combo.`,
    ORDERED_ITEM_COMBO_LABEL: `Combo`,
    ORDERING_ITEM_ABSENCE_RESET: `Món hàng này đã lỗi thời. Món hàng đã được đặt lại về trạng thái ban đầu. Xin vui lòng thử lại.`,
    OUR_MENU: `Menu của chúng tôi`,
    OUTPOST_PICKUP: `Outpost pickup`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `Nhập số phòng outpost của bạn`,
    OUTPOST_ROOM_NUMBER_TITLE: `Số phòng`,
    OUT_OF_STOCK: `Hết hàng`,
    PAGE_NAVIGATION_TITLE: `Chạm vào một trong các tùy chọn bên dưới để chuyển đến một trang cụ thể trong menu. Có {{$1: total}} trang khả dụng.`,
    PARTIAL_PAYMENT_LINE: `Thanh toán một phần`,
    PARTIAL_PAYMENT_WARNING_TITLE: `Thanh toán một phần`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `Có một khoản thanh toán một phần cho đơn hàng này. Nếu bạn muốn quay lại`,
    PASSWORD: `Mật khẩu`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `Xin chào`,
    PAY_AT_CASHIER: `Mời quý khách đến quầy thu ngân để thanh toán.`,
    PAY_NOW: `Thanh toán bây giờ`,
    PAY_WITH: `Thanh toán bằng`,
    PAY_WITH_CREDIT: `Thanh toán bằng thẻ tín dụng`,
    PAY_WITH_DEBIT_CREDIT: `Thanh toán bằng Debit/credit`,
    PAYMENT: `Thanh toán`,
    PAYMENT_DETAILS: `Chi tiết thanh toán`,
    PAYMENT_LINE_LABEL_DONATION: `Quyên góp {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `Tổng tiền trước thế là {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `Thanh toán một phần cho {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `Dùng thẻ quà tặng từ {{$1: name}} cho {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `Coupon khuyến mãi từ {{$1: name}} cho {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `Coupon khuyến mãi từ {{$1: name}} cho {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `Thanh toán bằng EBT cho {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `Đổi điểm thưởng từ {{$1: name}} trị giá {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `Đổi phần thưởng từ {{$1: name}} trị giá {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `Dùng điểm thưởng từ {{$1: name}} cho {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `Thuế là {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `Tip là {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `Phí dịch vụ là {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `Phí dịch vụ là {{$1: amount}} chgo {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `Tổng tiền là {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `Số dư là {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `Số tiền thanh toán là {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `Chạm để thanh toán bằng tiền mặt`,
    PAYMENT_OPTION_LABEL_CARD: `Chạm để thanh toán bằng thẻ tín dụng`,
    PAYMENT_OPTION_LABEL_COUPON: `Chạm để dùng coupon`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `Chạm để dùng comp card`,
    PAYMENT_OPTION_LABEL_DONATION: `Chạm để quyên góp hoặc chỉnh sửa khoản quyên góp`,
    PAYMENT_OPTION_LABEL_EBT: `Chạm để thanh toán bằng EBT`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `Chạm để hoàn tiền bằng EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `Chạm để thanh toán bằng EBT Cash Benefit`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `Chạm để thanh toán bằng EBT Food Stamps`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `Chạm để thanh toán bằng thẻ quà tặng`,
    PAYMENT_OPTION_LABEL_LOYALTY: `Chạm để dùng điểm thưởng`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `Chạm để dùng điểm thưởng`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `Chạm để hoàn tất thanh toán`,
    PAYMENT_PROMPT_NFC: `Thanh toán bằng máy thẻ tín dụng bằng cách đút thẻ hoặc chạm điện thoại của bạn.`,
    PAYMENT_PROMPT_DIP: `Thanh toán bằng máy thẻ tín dụng bằng cách đút thẻ.`,
    PAYMENT_SUCCESSFUL: `Thanh toán thành công`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `Xin lỗi`,
    PAYMENT_KIOSK_TIMEOUT: `Xin lỗi`,
    PAYMENT_TOTAL: `Tổng tiền thanh toán`,
    PAYMENT_WAS_TAKEN: `Vui lòng lưu ý rằng thanh toán của bạn đã được thực hiện.`,
    PAYMENT_WAS_NOT_TAKEN: `Xin lưu ý thanh toán của bạn chưa được thực hiện. Đây không phải là xác nhận thanh toán.`,
    PHONE_NUMBER: `Số điện thoại`,
    PHONE_NUMBER_OPTIONAL: ``,
    PICK_UP: `Pick up`,
    PICK_UP_AT: `Pick up tại`,
    PICK_UP_ENTER_NUMBER: `Hãy chọn số và nhập nó vào phần dưới đây:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `Chào {{$1: guets name}}, hãy chọn số và nhập nó vào phần dưới đây:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `Hãy chọn một tracker và nhập số của nó:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `Chào {{$1: guest name}}, hãy chọn một tracker và nhập số của nó:`,
    PLACE_ORDER: `Đặt hàng`,
    PLEASE_ENTER_A_VALID_AMOUNT: `Hãy nhập số tiền hợp lệ để hoàn tiền`,
    PLEASE_USE_TEST_CARD: `Địa điểm này vẫn đang ở chế độ thử nghiệm. Xin hãy dùng thẻ thử nghiệm để thanh toán.`,
    PLEASE_WAIT: `Xin hãy đợi...`,
    PRICE: `Giá tiền là {{$1:price}}`,
    PRINTING_RECEIPT: `Đang in hóa đơn của bạn...`,
    PRINT_RECEIPT: `In Hóa D(ơn`,
    PRINT_RECEIPT_ERROR: `Xin lỗi`,
    PRINTED_RECEIPT_COMMAND: `Xin hãy nhớ lấy hóa đơn của bạn!`,
    PROCESSING_PAYMENT: `Đang thực hiện thanh toán...`,
    PROMOTED_MODIFIER: `Promoted`,
    QUANTITY_SELECT: `Đã chọn {{$1:quantity}}`,
    QUANTITY_SELECT_INCREASE: `Tăng số lượng`,
    QUANTITY_SELECT_DECREASE: `Giảm số lượng`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `Thoát ra`,
    QUICK_CHECKOUT: `Thoát khỏi thanh toán`,
    QUICK_NAV_TAP_TO_VIEW: `Chạm để xem:`,
    QUIZ_RESULTS_TITLE: `Kết quả`,
    QUIZ_RESULTS_EMPTY: `Không tìm thấy kết quả nào. Hãy thử lại với các câu trả lời khác.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `Chạm để xem kết quả tiếp theo. {{$1:index}} trên {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `Chạm để xem kết quả trước đó. {{$1:index}} trên {{$2:total}}`,
    QUIZ_STEP_ERROR: `Xin hãy trả lời tất cả câu hỏi trước khi tiếp tục.`,
    QUIZ_STEP_ANSWER_LABEL: `Chạm để trả lời bằng {{$1:badge name}}:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `Quét mã QR để nhận bản sao hóa đơn của bạn trên điện thoại.`,
    RECEIPT_AUTHORIZATION: `Authorization`,
    RECEIPT_CARD_NUMBER: `Số thẻ`,
    RECEIPT_CHECK_ID: `CHECK ID`,
    RECEIPT_DISCOUNTS: `Giảm giá`,
    RECEIPT_DONATION: `Quyên góp`,
    RECEIPT_FAILED: `Xin chào`,
    RECEIPT_FAILED_ITEM_86D: `Xin chào`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `Các món hàng sau không được bao gồm trong mã QR vì chúng không có PLU liên kết với chúng:`,
    RECEIPT_NOT_RECEIPT: `Đây không phải là hóa đơn hay bằng chứng mua hàng.`,
    RECEIPT_ORDER: `Đơn hàng`,
    RECEIPT_ORDER_TOTAL: `Tổng đơn hàng`,
    RECEIPT_PAY_AT_CASHIER: `XIN HÃY TRẢ TIỀN Ở QUẦY.`,
    RECEIPT_PICK_UP_AT_LABEL: `Nhận hàng tại`,
    RECEIPT_PICKUP_TIME_LABEL: `Giờ nhận hàng`,
    RECEIPT_DELIVERY_TIME_LABEL: `Giờ giao hàng`,
    RECEIPT_PRINTED: `Hóa đơn đã in`,
    RECEIPT_REFUNDED: `Hoàn tiền`,
    RECEIPT_REMAINING_BALANCE: `Số dư`,
    RECEIPT_SELF_SERVE: `Self-serve:`,
    RECEIPT_SPECIAL_REQUEST: `Yêu cầu đặc biệt`,
    RECEIPT_SUB_TOTAL: `Tổng tiền trước thuế`,
    RECEIPT_TAX_TOTAL: `Tổng tiền thuế`,
    RECEIPT_TIP_THANKS: `Tiền Tip (Xin cảm ơn!)`,
    RECEIPT_SERVICE_CHARGE: `Phí Dịch Vụ`,
    RECEIPT_TRANS_NO: `KIOSK TRANS NO`,
    RECEIPT_YOUR_CHECK_NUMBER: `Số check của bạn là`,
    RECOMMENDATIONS: `Gợi ý`,
    RECOMMENDED_FOR_YOU: `Gợi ý cho bạn`,
    REFUND: `Hoàn tiền`,
    REFUNDER_ALREADY_REFUNDED: `Đã hoàn tiền`,
    REFUNDER_DELAY_MESSAGE: `Hoàn tiền sẽ mất vài ngày để hiển thị trên bảng sao kê tài khoản của bạn.`,
    REFUNDER_INSTRUCTIONS: `Tìm kiếm đơn hàng bằng số authorization trên hóa đơn`,
    REFUNDER_SEARCH_PLACEHOLDER: `Số authorization trên hóa đơn`,
    REFUNDER_TITLE: `Hoàn tiền cho một đơn hàng`,
    REFUNDER_SEARCHING_TITLE: `Đang tìm`,
    REFUNDER_RESULTS_TITLE: `Những đơn hàng`,
    REFUNDER_RESULTS_EMPTY: `Không tìm thấy đơn hàng. Xin hãy kiểm tra lại tiêu chí tìm kiếm của bạn và thử lại.`,
    REFUNDER_REFUNDING_TITLE: `Đang hoàn tiền`,
    REFUNDER_REFUND_ERROR: `Đã xảy ra lỗi khi xử lý hoàn tiền cho bạn. Vui lòng thử lại hoặc liên hệ với nhân viên tư vấn để được trợ giúp thêm.`,
    REFUNDER_REFUND_SUCCESS: `Hoàn tiền thành công! Giao dịch sẽ được xử lý trong thời gian ngắn.`,
    REFUNDER_REFUND_SUCCESS_BACK: `Tìm kiếm lại`,
    REFUNDER_SEARCH_INPUT_ERROR: `Vui lòng nhập một số authorization trên hóa đơn`,
    REFUNDER_SEARCH_ERROR: `Chúng tôi không thể tìm thấy đơn hàng của bạn. Vui lòng thử lại hoặc liên hệ với nhân viên tư vấn để được trợ giúp thêm.`,
    REFUNDING: `Đang xử lý hoàn tiền...`,
    REFUND_FAILED: `Hoàn tiền không thành công. Vui lòng thử lại sau.`,
    REMOVE: `Gỡ bỏ`,
    REMOVE_CARD: `Đừng quên lấy thẻ của bạn.`,
    REMOVE_COMP_CARD: `Gỡ bỏ thẻ Comp`,
    REMOVE_COUPON: `Gỡ bỏ phiếu giảm giá`,
    REMOVE_GIFT_CARD: `Gỡ bỏ`,
    REMOVE_TIP: `Gỡ bỏ tiền Tip`,
    REMOVING_COUPON: `Đang gỡ bỏ phiếu giảm giá`,
    REPEAT_PASSWORD: `Lặp Lại Mật Khẩu`,
    RESET: `Đặt lại`,
    REWARDS: `Phần thưởng`,
    REWARDS_LOGGED_IN: `Phần thưởng`,
    REWARDS_APPLICABLE_TO_ORDER: `Áp dụng cho đơn hàng của bạn`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `Chứa áp dụng cho đơn hàng của bạn`,
    REWARDS_EDIT: `Sửa điểm thưởng`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} điểm`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} bữa ăn`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} điểm`,
    SAVE: `Lưu`,
    SAVE_CARD: `Lưu thẻ trên tài khoản cho những đơn hàng trong tương lai.`,
    SCAN_COUPON_BELOW: `Bạn có thể quét coupons bằng máy quét bên dưới.`,
    SCAN_YOUR_GIFT_CARD: `Quét thẻ quà tặng của bạn`,
    SEARCH: `Tìm kiếm`,
    SEARCH_BEGIN: `Nhập từ khóa tìm kiếm bên dưới để bắt đầu tìm kiếm.`,
    SEARCH_EMPTY: `Không tìm thấy kết quả nào. Hãy thử một từ khóa tìm kiếm khác.`,
    SEARCH_HINT: `Tìm kiếm món hàng bằng bất kỳ tổ hợp tên hoặc mô tả nào.`,
    SECRET_MENU_IMAGE_ALT: `Chạm để xem menu bí ẩn`,
    SELECT_DATE: `Chọn ngày`,
    SELF_SERVE: `Self-serve`,
    SEND: `Gửi`,
    SEND_LOYALTY_SMS: `Gửi tin nhắn SMS`,
    SEND_ORDER_UI_TIMEOUT: `Chào quý khách`,
    SENT_LOYALTY_SIGNUP_SMS: `Tin nhắn SMS đã được gửi! Hãy kiểm tra điện thoại và đăng ký khi bạn có thể.`,
    SENDING_ORDER_KITCHEN: `Đang gửi đơn hàng đến nhà bếp...`,
    SENDING_ORDER_VALIDATION: `Đang xác nhận đơn hàng....`,
    SENDING_RECEIPT: `Đang gửi hóa đơn...`,
    SENDING_SMS: `Đang gửi tin nhắn SMS...`,
    SERVICE_CHARGE: `Phí dịch vụ`,
    SHOW: `Hiển thị`,
    SHOW_NUTRITION: `Hiển thị nutrition facts`,
    SHOW_STAFF_FIRST: `Xin hãy đưa cho nhân viên xem tin nhắn này trước khi thoát. Bạn chắc chắn muốn thoát?`,
    SIGNUP_CTA: `Đăng ký tài khoản!`,
    SIGN_OUT: `Đăng xuất`,
    SIGN_UP: `Đăng ký`,
    SIGNUP_BENEFITS: `Tại tài khoản để lưu thông tin thẻ tín dụng và các món yêu thích để thanh toán dễ dàng.`,
    SIGNUP_LOYALTY: `Đăng ký thành viên`,
    SKIP: `Skip`,
    SPECIAL_REQUESTS: `Yêu cầu đặc biệt`,
    SPECIAL_REQUESTS_EXAMPLE: `ví dụ: nước sốt để riêng`,
    SPECIAL_REQUESTS_FINEPRINT: `Việc thay đổi và yêu cầu có thể phát sinh thêm phí.`,
    SPECIAL_REQUESTS_ADD: `Thêm yêu cầu đặc biệt`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `Yêu cầu đặc biệt quá dài`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `Vui lòng chỉ sử dụng chữ cái`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `Hãy nhập một yêu cầu đặc biệt`,
    SR_REMOVE_ITEM_FROM_CART: `Xóa món hàng trong giỏ hàng`,
    STARTING_ORDER: `Đang bắt đầu đơn hàng...`,
    UPDATING_ORDER: `Đang cập nhật đơn hàng...`,
    START_ORDER_BY_SCANNING: `Bắt đầu đơn hàng của bạn bằng cách quét một món hàng ở phía dưới kiosk.`,
    START_NEW_ORDER: `Bắt đầu một đơn hàng khác`,
    STORED_VALUE_REMAINING_BALANCE: `số dư`,
    STORE_INFO: ``,
    STORE_INFORMATION: `Thông tin nhà hàng`,
    STUDENT_CARD: `Thẻ Học Sinh`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `Xin lỗi, thẻ sinh viên này không còn tiền.`,
    STUDENT_CARD_SUBTITLE_HID: `Chạm thẻ học sinh của bạn để thanh toán`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `Chạm hoặc quét thẻ học sinh của bạn để thanh toán`,
    STUDENT_CARD_SUBTITLE_MSR: `Quét thẻ học sinh của bạn để thanh toán`,
    SUBMIT: `Submit`,
    SUBTOTAL: `Tổng tiền trước thuế`,
    SUBTOTAL_REDUCED: `Tổng tiền trước thuế được giảm`,
    SUBTOTAL_INCREASED: `Tổng tiền trước thuế mới`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `Bạn đang tiết kiệm với combo!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `Bạn tiết kiệm`,
    SUCCESS: `Thành công`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `Thay đổi địa điểm`,
    SWITCH_TO_CATERING: `Thay đổi đến catering`,
    SWITCH_TO_WEB: `Thay đổi đến đặt hàng online`,
    SWIPE_YOUR_GIFT_CARD: `Quẹt thẻ quà tặng để thanh toán`,
    SWIPE_YOUR_COMP_CARD: `Quẹt comp card của bạn để thanh toán`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `Quẹt hoặc quét thẻ quà tặng của bạn để thanh toán`,
    TAKING_LONGER_THAN_USUAL: `Mất nhiều thời gian hơn bình thường`,
    TAP_HERE_FOR_LANGUAGE: `Chạm vào đây để chọn {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `Chạm bên ngoài để đóng`,
    TAP_TO_REDEEM: `Chạm để đổi điểm`,
    TAXES: `Thuế`,
    TERMS_OF_SERVICE: `Điều khoản dịch vụ`,
    TERMS_OF_SERVICE_LOAD_FAILED: `Không thể tải tài khoản dịch vụ`,
    TEXT_RECEIPT: `Gửi hoá đơn qua tin nhắn`,
    TEXT_RECEIPT_SEND_FAILED: `Không thể gửi hoá đơn qua tin nhắn`,
    TEXT_RECEIPT_SEND_SUCCESS: `Hóa đơn đã được gửi!`,
    TEXT_YOU_WHEN_READY: `Chúng tôi sẽ nhắn tin cho bạn khi đơn hàng đã sẵn sàng.`,
    THANK_YOU: `Xin cảm ơn!`,
    THEN_PRESS_BUTTON_1: `Sau đó ấn`,
    THEN_PRESS_BUTTON_2: `nút`,
    TIP: `Tiền Tip`,
    TIPPING: `Đang Tip...`,
    TIP_AMOUNT_TOO_HIGH: `Số tiền Tip quá cao.`,
    TIP_AMOUNT_TOO_LOW: `Số tiền Tip quá thấp.`,
    TIP_FAILED: `Xin lỗi! Không thể thêm tiền tip. Xin hãy thử lại.`,
    TIP_CANNOT_BE_MODIFIED: `Xin lỗi! Bạn không thể thay đổi tiền Tip sau khi bạn đã thanh toán đơn hàng.`,
    TIP_LABEL_PERCENT: `Chạm để thêm {{$1: percent}}% ({{$2: amount}}) tip`,
    TIP_LABEL_FIXED: `Chạm để thêm {{$1: percent}}`,
    TIP_LABEL_CUSTOM: `Chạm để thêm Tip tùy chỉnh`,
    TIP_LABEL_NONE: `Chạm để gỡ bỏ tiền Tip`,
    TO_GO: `Mang đi`,
    TOTAL: `Tổng cộng`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `Giá tiền của một số món hàng đã thay đổi trong đơn hàng của bạn.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `Tổng tiền trước thuế đã thay đổi và bây giờ là`,
    TOTAL_CHANGED_LEADING_TEXT: `Tổng tiền đã thay đổi và bây giờ là`,
    TOTAL_CHANGED_TRAILING_TEXT: `Bạn có muốn tiếp tục với đơn hàng không?`,
    TOTAL_PAID: `Tổng tiền đã trả`,
    TOTAL_REMAINING: `Tổng số dư`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `Thử Lại`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `Chúng tôi không tìm được vị trí của bạn. Xin hãy nhập địa chỉ của bạn.`,
    UNAVAILABLE_ITEM: `Xin lỗi`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} Calories`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} Protein`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} Tinh Bột`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} Chất Béo`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} đường`,
    UP_TO_X: `đến khoảng {{$1: number}}`,
    USE_COMP_CARD: `Sử dụng Comp Card`,
    USE_COUPON: `Dùng Coupon`,
    USE_EBT_CARD: `Thẻ EBT`,
    USE_EBT_CASH_BENEFIT: `EBT Cash Benefit`,
    USE_EBT_FOOD_STAMP: `EBT Food Stamp`,
    USE_GIFT_CARD: `Sử dụng phiếu quà tặng`,
    USERNAME: `Tên tài khoản`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `Email không hợp lệ`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} là bắt buộc`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `Mục này là bắt buộc`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `Vui lòng chỉ dùng chữ cái và số`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `Vui lòng chỉ dùng chữ cái`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `Mật khẩu phải chứa ít nhất 1 chữ số`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `Số điện thoại không hợp lệ`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `Mã vùng cần là số`,
    VENDOR_UNAVAILABLE_MESSAGE: `Nhà cung cấp này hiện đang đóng cửa. Vui lòng kiểm tra giờ làm việc và quay lại vào thời gian khác`,
    VEHICLE_COLOR: `Màu xe`,
    VEHICLE_MAKE: `Hãng xe`,
    VEHICLE_MODEL: `Model xe`,
    VERIFY_ACCOUNT: `Xác nhận tài khoản`,
    VERIFY_ACCOUNT_CTA: `Xác nhận tài khoản của bạn để bắt đầu đặt hàng.`,
    VIDEO_LOAD_FAILED: `Không thể tải video`,
    VIEW: `Xem`,
    WE_APOLOGIZE: `Chúng tôi xin lỗi nếu gây ra sự bất tiện nào.`,
    WEIGHING_INSTRUCTIONS: `Đặt món hàng lên cân`,
    WELCOME_BACK: `Chào mừng quay trở lại! Món hàng được chọn riêng cho bạn:`,
    WELCOME_BACK_WITH_NAME: `Chào mừng quay trở lại, {{$1: guest name}}! Món hàng được chọn riêng cho bạn:`,
    WELCOME_TO: `Chào mừng đến với {{$1: org name}}!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `Chọn thời gian đặt hàng`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `Bạn muốn đặt hàng ở đâu?`,
    YES: `Có`,
    YOU_PREVIOUSLY_ORDERED: `Bạn đã từng đặt hàng`,
    YOUR_CURRENT_LOCATION: `Địa điểm hiện tại của bạn`,
    YOUR_NAME: `Tên của bạn`,
    YOUR_ORDER: `Đơn hàng của bạn`,
    YOUR_SUBTOTAL: `Tổng trước thuế`,
    ZOOM_TOGGLE_ON: `Chạm để kích hoạt chức năng Pinch to Zoom`,
    ZOOM_TOGGLE_OFF: `Chạm để dừng chức năng Pinch to Zoom`,
    ZOOM_INSTRUCTIONS: `Chức năng Pinch to Zoom đã được kích hoạt. Dùng hai ngón tay để phóng to và thu nhỏ.`,
    STARBUCKS_COVER_1_BUTTON: `Tôi biết mình muốn gì`,
    STARBUCKS_COVER_2_BUTTON: `Đưa tôi tham quan`,
    STARBUCKS_COVER_2_TITLE: `Trải nghiệm, Nếm thử, Học hỏi`,
    STARBUCKS_COVER_PROMO_A: `Tìm cà phê`,
    STARBUCKS_COVER_PROMO_B: `Starbucks Rewards`,
    STARBUCKS_EXPERIENCES_TITLE: `Trải nghiệm`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `Đắm mình vào nghệ thuật, sân khấu và sự đổi mới của cà phê khi bạn đặt một Trải nghiệm Đặc trưng`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `Đặt cho hôm nay`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `Đặt cho lần sau`,
    STARBUCKS_EXPERIENCES_BACK: `Quay lại Trải nghiệm`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `Tìm hiểu thêm`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `Đến menu`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `Tôi đang ở đâu?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `Bạn đang ở đây`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `Nhà vệ sinh`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `Chỗ ngồi tự do`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `Tìm một địa điểm`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `Kéo bằng ngón tay để khám phá không gian.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `Chạm vào một địa điểm được đánh dấu để tìm hiểu thêm.`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `Tính phiêu lưu`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `Bạn thích cà phê của mình phiêu lưu đến mức nào?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `Hương vị ưa thích`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `Khi nghĩ về cà phê của mình, hương vị nào nghe hấp dẫn nhất với bạn?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `Độ đậm`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `Bạn thích cà phê của mình đậm đến mức nào?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `Cách gọi cà phê ưa thích`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `Bạn thường thích gọi cà phê của mình như thế nào?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `Chạm để chỉnh sửa`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `Xác nhận lựa chọn của bạn`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `Bắt đầu lại`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `Có vẻ như bạn sẽ thích`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `Chỉ mua hạt cà phê, hoặc chúng tôi gợi ý thức uống bên dưới với loại hạt này:`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `Xem toàn bộ menu`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `Bắt đầu lại`,
    STARBUCKS_VIEW_WAYFINDER: `Đưa tôi tham quan`,
    STARBUCKS_VIEW_COFFEE_FINDER: `Thu hẹp lựa chọn của tôi`,
    STARBUCKS_VIEW_EXPERIENCES: `Xem Trải nghiệm`,
    'cover.session.timeout': `Đã xảy ra lỗi. Xin vui lòng thử lại.`,
    'cover.reduced-height.button': `Bắt đầu đặt hàng`,
    'cover.loyalty.title': `Chào mừng`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `Đăng nhập với điểm thưởng`,
    'cover.loyalty.guest': `Bắt đầu với tư cách khách`,
    'guest-identifier.button.quit': `Thoát`,
    'guest-identifier.button.skip': `Bỏ qua`,
    'guest-identifier.button.back': `Quay lại`,
    'guest-identifier.button.next': `Tiếp tục`,
    'guest-identifier.button.submit.cover': `Tiếp tục`,
    'guest-identifier.button.submit.edit': `Tiếp tục`,
    'guest-identifier.button.submit.checkout': `Tiếp tục`,
    'guest-identifier.phone.tos.button-back': `Quay lại`,
    'guest-identifier.phone.tos.title': `Điều khoản dịch vụ`,
    'guest-identifier.phone.tos.link': `Điều khoản dịch vụ số điện thoại`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `Đăng nhập bằng tài khoản điểm thưởng của bạn`,
    'guest-identifier.name.loyalty-button': `Đăng nhập với điểm thưởng`,
    'guest-identifier.name.loyalty-separator': `hoặc`,
    'guest-identifier.name.loyalty-error-title': `Rất tiếc! Không tìm thấy tên`,
    'guest-identifier.name.loyalty-error-description': `Xin lỗi, chúng tôi không thể tìm thấy tên liên kết với tài khoản. Xin hãy nhập tên của bạn bên dưới`,
    'inactivity-timer.button.continue': `Có, tôi cần thêm thời gian`,
    'inactivity-timer.button.exit': `Không, tôi đã xong`,
    'item-card.add.with-quantity': `Thêm ({{$1: quantity}})`,
    'image.scan.default.alt': `Quét mã vạch hoặc mã QR của bạn`,
    'loyalty.view_coupons': `Xem coupon`,
    'loyalty.add_coupons': `Thêm coupon`,
    'loyalty.label.manual_redemption': `Mã đổi thưởng`,
    'loyalty.label.manual_redemption_instructions': `Nhập mã đổi thưởng để đổi phần thưởng của bạn`,
    'loyalty.label.welcome.new-user': `Xin chào, {{$1: user}}! Bây giờ bạn đã có tài khoản điểm thưởng`,
    'loyalty.reward_label.payment_unapplied': `Áp dụng thanh toán vào thẻ đã lưu trên hệ thống`,
    'loyalty.reward_label.redeemable_unredeemed': `Đổi bằng {{$1: points}} điểm`,
    'loyalty.reward_label.payment_at_checkout': `Thanh toán có thể được áp dụng khi thanh toán`,
    'loyalty.reward_group_label.payment': `Điểm thưởng thanh toán`,
    'loyalty.rewards.payment-reward.name': `Thanh toán bằng số dư`,
    'loyalty.rewards.payment-reward.name-with-amount': `Thanh toán bằng số dư ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `Số dư hiện tại của bạn`,
    'loyalty.rewards.card-on-file-payment.description': `Thanh toán sẽ được tính vào thẻ đã lưu trên hệ thống của bạn.`,
    'loyalty.redemption_auth.back_to_rewards': `Quay lại phần thưởng`,
    'loyalty.redemption_auth.subtitle': `Quét mã vạch đổi thưởng để đổi phần thưởng của bạn`,
    'loyalty.redemption_auth.submit': `Đổi phần thưởng`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `Nhập tên của bạn`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `Xin hãy chấp nhận các điều khoản và điều kiện để tiếp tục.`,
    'loyalty.checkout-signup.header': `Cơ hội cuối cùng để đăng ký và nhận phần thưởng cho đơn hàng này!`,
    'loyalty.checkout-signup.skip': `Bỏ qua và thanh toán`,
    'loyalty.checkout-signup.success.new-account.title': `Đã tạo tài khoản mới`,
    'loyalty.checkout-signup.success.new-account.description': `Cảm ơn bạn đã tham gia, bạn sẽ nhận được phần thưởng cho đơn hàng này!`,
    'loyalty.checkout-signup.success.existing-account.title': `Tài khoản đã tồn tại`,
    'loyalty.checkout-signup.success.existing-account.description': `Bạn đã đăng ký trước đó bằng số này. Bây giờ bạn đã đăng nhập.`,
    'loyalty.checkout-signup.error.title': `Lỗi khi tạo tài khoản`,
    'loyalty.checkout-signup.error.description': `Đã xảy ra lỗi trong quá trình tạo tài khoản`,
    'loyalty.checkout-signup.error.skip': `Bỏ qua và thanh toán`,
    'loyalty.checkout-signup.error.try-again': `Thử lại`,
    'menu.item.reset': `Đặt lại món hàng`,
    'menu.mod-group.quick-select': `Chọn nhanh`,
    'menu.mod-group.quick-select-active': `Đã chọn`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `Quét món hàng để bắt đầu đặt hàng`,
    'menu.page.scanner.scanned.title': `Món hàng trong giỏ`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `Xem món hàng đã quét`,
    'order-history.button.add-to-order': `Thêm món hàng có sẵn ({{$1: number}})`,
    'order-history.title': `Lịch sử đặt hàng`,
    'order-history.subtitle': `Tất cả đơn hàng trước đây của bạn sẽ hiển thị ở đây. Tương tác với các món hàng để xem hoặc thêm chúng vào đơn hàng hiện tại của bạn. Bạn có thể thêm tất cả món hàng của một đơn hàng chỉ với một lần chạm.`,
    'order-history.next-page': `Tiếp`,
    'order-history.previous-page': `Trước`,
    'order-history.screen.close': `Đóng`,
    'order-history.screen.error.title': `Đã xảy ra lỗi`,
    'order-history.screen.error.subtitle': `Không thể tải lịch sử đơn hàng - xin vui lòng thử lại sau.`,
    'order-history.screen.error.button.back': `Quay lại`,
    'order-history.screen.error.button.retry': `Thử lại`,
    'order-history.screen.no-orders': `Không tìm thấy đơn hàng trước đây nào. Khi bạn đặt hàng, hãy quay lại đây để xem.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `Một số món hàng trong đơn hàng này không thể đặt lại nhanh. Xin hãy thêm các món hàng bằng cách chạm vào từng món riêng lẻ.`,
    'order-history.section.button.view-all': `Xem thêm đơn hàng của tôi`,
    'order-history.topbar.button.back': `Quay lại`,
    'loyalty.unapplicable_rewards_warning_title': `Phần thưởng không áp dụng được`,
    'loyalty.unapplicable_rewards_warning_description': `Để đổi phần thưởng đã chọn, xin hãy thêm các món hàng phù hợp vào giỏ hàng của bạn. Phần thưởng và giảm giá sẽ được áp dụng khi thanh toán.`,
    'loyalty.unapplicable_rewards_warning_confirm': `Áp dụng`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `Nhập thủ công`,
    'loyalty.button.menu.authed': `Phần thưởng`,
    'loyalty.button.menu.unauthed': `Phần thưởng`,
    'loyalty.button.checkout.authed': `Phần thưởng`,
    'loyalty.button.checkout.unauthed': `Phần thưởng`,
    'loyalty.error.reward_failed_to_apply': `Không thể áp dụng phần thưởng. Xin vui lòng thử lại.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `Bỏ qua và tiếp tục đến menu`,
    'loyalty.login-options.button.skip.checkout': `Bỏ qua và tiếp tục thanh toán`,
    'loyalty.login-options.button.skip.dining-option-collection': `Bỏ qua và tiếp tục thanh toán`,
    'loyalty.login-options.title': `Chọn một tùy chọn để đăng nhập hoặc tiếp tục với tư cách khách`,
    'loyalty.login-options.subtitle': `Bạn luôn có thể đăng nhập sau`,
    'loyalty.login-options.signup.link': `Chưa có tài khoản? Đăng ký`,
    'loyalty.login-options.barcode.title': `Quét mã vạch`,
    'loyalty.login-options.barcode.subtitle': `Quét mã vạch của bạn để đăng nhập`,
    'loyalty.login-options.email-phone-number.title': `Email và số điện thoại`,
    'loyalty.login-options.email-phone-number.subtitle': `Nhập email và số điện thoại của bạn để đăng nhập`,
    'loyalty.login-options.email-password.title': `Email và mật khẩu`,
    'loyalty.login-options.email-password.subtitle': `Nhập email và mật khẩu của bạn để đăng nhập`,
    'loyalty.login-options.username-password.title': `Tên đăng nhập và mật khẩu`,
    'loyalty.login-options.username-password.subtitle': `Nhập tên đăng nhập và mật khẩu của bạn để đăng nhập`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `Số điện thoại`,
    'loyalty.login-options.phone-number.subtitle': `Nhập số điện thoại của bạn để đăng nhập`,
    'loyalty.login-options.card-number.title': `Số thẻ`,
    'loyalty.login-options.card-number.subtitle': `Nhập số thẻ của bạn để đăng nhập`,
    'loyalty.login-options.email.title': `Email`,
    'loyalty.login-options.email.subtitle': `Nhập email của bạn để đăng nhập`,
    'loyalty.login-options.or': `HOẶC`,
    'loyalty.login-options.popup.close': `Đóng`,
    'loyalty.error.or': `HOẶC`,
    'loyalty.login-error.saved-form': `Thông tin bạn đã gửi:`,
    'loyalty.login-error.try-again.button': `Thử lại`,
    'loyalty.otp.enter-code.title': `Nhập mã chúng tôi đã gửi cho bạn`,
    'loyalty.otp.sent-to.email': `Chúng tôi đã gửi mã qua email đến {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `Chúng tôi đã gửi mã qua tin nhắn đến {{$1: masked phone number}}`,
    'loyalty.otp.verify': `Xác minh`,
    'loyalty.otp.resend': `Gửi lại mã`,
    'loyalty.otp.code.error.invalid': `Mã đó không đúng. Xin vui lòng thử lại.`,
    'loyalty.otp.send-error.message': `Chúng tôi không thể tìm thấy chính xác một tài khoản khớp với thông tin đó. Xin hãy kiểm tra lại và thử lại.`,
    'loyalty.login.fallback.phone-number.button': `Dùng số điện thoại thay thế`,
    'loyalty.login.fallback.barcode.button': `Quét mã vạch hoặc mã QR thay thế`,
    'loyalty.login.fallback.card-number.button': `Dùng số thẻ thay thế`,
    'loyalty.login.fallback.email.button': `Dùng email thay thế`,
    'loyalty.login.fallback.email-phone-number.button': `Dùng email và số điện thoại thay thế`,
    'loyalty.login.fallback.email-password.button': `Dùng email và mật khẩu thay thế`,
    'loyalty.login.fallback.username-password.button': `Dùng tên đăng nhập và mật khẩu thay thế`,
    'loyalty.login.auth-method.phone-number.title': `Số điện thoại`,
    'loyalty.login.auth-method.barcode.title': `Quét mã vạch hoặc mã QR`,
    'loyalty.login.auth-method.card-number.title': `Số thẻ`,
    'loyalty.login.auth-method.email.title': `Email`,
    'loyalty.login.auth-method.email-phone-number.title': `Email và số điện thoại`,
    'loyalty.login.auth-method.email-password.title': `Email và mật khẩu`,
    'loyalty.login.auth-method.username-password.title': `Tên đăng nhập và mật khẩu`,
    'vitrine.error.order_validation_failed': `Không thể xác thực đơn hàng. Xin vui lòng thử lại.`,
    'vitrine.error.handshake_failed': `Không thể kết nối với kiosk. Xin vui lòng liên hệ với nhân viên để được trợ giúp.`,
    'vitrine.error.request_timeout': `Không thể hoàn tất yêu cầu. Xin vui lòng thử lại.`,
    'vitrine.error.request_aborted': `Không thể hoàn tất yêu cầu. Xin vui lòng thử lại.`,
    'vitrine.error.analytics_send_error': `Không thể gửi dữ liệu phân tích. Xin vui lòng thử lại.`,
    'vitrine.error.garcon_incompatible_build': `Không thể kết nối với kiosk. Xin vui lòng liên hệ với nhân viên để được trợ giúp.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `Không thể tìm thấy tài khoản của bạn`,
    'vitrine.error.loyalty-login-no-matching-user-message': `Chúng tôi không thể tìm thấy người dùng với thông tin bạn cung cấp.`,
    'vitrine.error.loyalty_not_enough_points': `Tài khoản của bạn không có đủ điểm để đổi các phần thưởng đã chọn.`,
    'vitrine.error.order_total_above_max': `Tổng đơn hàng đã vượt quá mức tối đa cho phép. Xin vui lòng liên hệ với nhân viên để được trợ giúp.`,
    'vitrine.error.empty_menu': `Menu bạn đã chọn hiện đang trống. Xin hãy thử một tùy chọn đặt hàng khác.`,
    'maitred.error.integration_bad_config': `Có vẻ như có sự cố với cấu hình của kiosk. Xin vui lòng liên hệ với nhân viên để được trợ giúp.`,
    'checkout.done.expo_receipt.error': `Không thể in hóa đơn. Xin vui lòng thử lại.`,
    'checkout.done.expo_receipt.success': `Đã gửi hóa đơn! Xin hãy nhờ nhân viên hỗ trợ.`,
    'checkout.done.print-receipt.out-of-paper': `Máy in hết giấy. Xin hãy đến gặp nhân viên để nhận hóa đơn của bạn.`,
    'refunder.viewing-results.button.cancel': `Hủy`,
    'refunder.viewing-results.button.refund-all': `Hoàn tiền tất cả`,
    'refunder.viewing-results.button.view-transaction': `Xem giao dịch`,
    'refunder.viewing-results.button.done': `Xong`,
    'refunder.viewing-results.button.back': `Quay lại`,
    'refunder.viewing-results.button.search': `Tìm kiếm đơn hàng`,
    'refunder.viewing-results.refund-order.error-print-receipt': `Đơn hàng đã được hoàn tiền thành công, nhưng chúng tôi không thể in hóa đơn. Xin hãy thử in lại.`,
    'refunder.viewing-results.refund-order.success': `Đơn hàng đã được hoàn tiền thành công.`,
    'refunder.viewing-results.refund-order.error': `Không thể hoàn tiền đơn hàng. Xin vui lòng thử lại.`,
    'refunder.viewing-results.order.refunded': `Đơn hàng đã hoàn tiền`,
    'refunder.viewing-results.order.total': `Tổng đơn hàng`,
    'refunder.search-form.button.back': `Quay lại`,
    'refunder.search-form.button.search': `Tìm kiếm`,
    'refunder.viewing-order.title': `Tất cả giao dịch cho đơn hàng #{{$1: order number}}`,
    'refunder.viewing-order.subtitle': `Xin hãy chọn giao dịch bạn muốn hoàn tiền.`,
    'refunder.viewing-order.button.cancel': `Hủy`,
    'refunder.viewing-order.button.refund': `Hoàn tiền`,
    'refunder.viewing-order.button.refund-partial': `Hoàn tiền một phần`,
    'refunder.viewing-order.button.retry': `Thử lại`,
    'refunder.viewing-order.button.done': `Xong`,
    'refunder.viewing-order.button.back': `Quay lại`,
    'refunder.viewing-order.refund-transaction.error': `Không thể hoàn tiền giao dịch. Xin vui lòng thử lại.`,
    'refunder.viewing-order.refund-transaction.success': `Đã hoàn tiền giao dịch thành công.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `Giao dịch đã được hoàn tiền thành công, nhưng chúng tôi không thể in hóa đơn. Xin hãy thử in lại.`,
    'refunder.viewing-order.transaction.total': `Tổng`,
    'refunder.viewing-order.transaction.refunded': `Đã hoàn tiền`,
    'refunder.viewing-order.error.title': `Lỗi`,
    'refunder.viewing-order.error.message': `Không thể tải đơn hàng. Xin vui lòng thử lại.`,
    'refunder.viewing-order.error.button.retry': `Thử lại`,
    'refunder.viewing-order.error.button.back': `Quay lại`,
    'refunder.partial-transaction-refund.error.amount-too-high': `Số tiền quá cao.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `Số tiền quá thấp.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `Số tiền không hợp lệ.`,
    'refunder.partial-transaction-refund.error.amount-required': `Số tiền là bắt buộc.`,
    'refunder.partial-transaction-refund.error': `Đã xảy ra sự cố khi xử lý hoàn tiền. Xin vui lòng thử lại.`,
    'refunder.partial-transaction-refund.button.submit': `Gửi hoàn tiền một phần`,
    'refunder.partial-transaction-refund.button.back': `Quay lại`,
    'refunder.partial-transaction-refund.title': `Hoàn tiền một phần giao dịch`,
    'refunder.partial-transaction-refund.hint': `Xin hãy nhập số tiền bạn muốn hoàn. Số tiền tối đa là {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `Số tiền`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.group-ordering.actions.change-recipient': `Chỉnh sửa người nhận`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `Gán món hàng cho`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `Hủy`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `Thêm mới`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `Gán lại`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `Món hàng này dành cho ai?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `Gán cho khách này`,
    'checkout.cart.starbucks-stars': `Món {{$1: amount}} \u2605`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'menu.nav.starbucks.menu': `Menu chính`,
    'menu.nav.starbucks.experiences': `Trải nghiệm`,
    'menu.nav.starbucks.wayfinder': `Chỉ đường`,
    'menu.secret-menu.access-code.title': `Nhập mã truy cập`,
    'menu.secret-menu.access-code.button.back': `Quay lại`,
    'menu.secret-menu.access-code.button.submit': `Gửi`,
    'menu.secret-menu.access-code.error': `Mã truy cập không hợp lệ`,
    'menu.secret-menu.access-code.success': `Mã truy cập được chấp nhận`,
    'menu.toast.added-to-cart': `Đã thêm vào giỏ hàng`,
    'menu.toast.combo-savings': `Tiết kiệm với combo!`,
    'menu.toast.discount-applied': `Đã áp dụng giảm giá!`,
    'menu.exit-verification.title': `Yêu cầu xác minh của quản lý`,
    'menu.exit-verification.description': `Cần mã truy cập của nhân viên để thoát. Xin hãy nhờ nhân viên hỗ trợ.`,
    'menu-item.starbucks-stars': `{{$1: amount}} \u2605`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `Xin hãy đặt món hàng của bạn lên cân.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `Nặng`,
    'menu-item.scale.price-per-unit': `{{$1: price}} mỗi {{$2: unit}}`,
    'menu-item.scale.price': `Giá`,
    'menu-item.scale.instructions': `Dùng cân để cân món hàng của bạn. Để đặt lại, chạm vào nút được chỉ định trên cân.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `Đang cân...`,
    'menu-item.scale.error-reading-weight': `Lỗi khi đọc trọng lượng. Xin vui lòng thử lại.`,
    'menu-item.scale.error-no-weight': `Xin hãy cân món hàng của bạn nếu bạn muốn thêm vào đơn hàng.`,
    'menu-item.scale.no-scale': `Không phát hiện thấy cân. Xin vui lòng liên hệ với nhân viên để được trợ giúp.`,
    'also-consider.title': `Cũng có thể cân nhắc...`,
    'also-consider.back-to-item': `Quay lại món hàng`,
    'also-consider.add-to-order': `Thêm vào giỏ hàng`,
    'also-consider.skip-add-on': `Bỏ qua món thêm`,
    'menu-item.assorted.title': `Tạo phần tổng hợp của bạn`,
    'menu-item.assorted.count': `Đã chọn {{$1: count}} trên {{$2: total}}`,
    'menu-item.row-size-mod.option.none': `Không có`,
    'menu-item.high-sugar-warning.description': `Cảnh báo: Biểu tượng này cho biết hàm lượng đường bổ sung của món hàng này bằng hoặc cao hơn giới hạn khuyến nghị hằng ngày về đường bổ sung cho chế độ ăn 2.000 calo (50 g). Việc ăn hoặc uống nhiều đường bổ sung trong thời gian dài có thể làm tăng nguy cơ mắc bệnh tiểu đường loại 2, tăng cân và sâu răng.`,
    'menu-item.high-sodium-warning.description': `Cảnh báo: Biểu tượng này cho biết hàm lượng natri (muối) của món hàng này cao hơn giới hạn khuyến nghị hằng ngày (2.300 mg). Việc tiêu thụ nhiều natri có thể làm tăng huyết áp và nguy cơ mắc bệnh tim và đột quỵ.`,
    'menu-item.group-ordering.items-for': `Đặt hàng nhóm - Món hàng dành cho:`,
    'menu-item.group-ordering.prompt.title': `Đặt hàng theo nhóm?`,
    'menu-item.group-ordering.prompt.description': `Tùy chọn đặt hàng nhóm sẽ hỏi bạn mỗi món hàng dành cho thành viên nào trong nhóm của bạn. Chạm “Có” để bật đặt hàng nhóm. Chạm “Không” nếu bạn muốn tiếp tục với tùy chọn này.`,
    'menu-item.group-ordering.prompt.button.accept': `Có, đặt hàng nhóm`,
    'menu-item.group-ordering.prompt.button.decline': `Không, cảm ơn`,
    'menu-item.group-ordering.add-recipient': `Thêm mới`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `Thêm người nhận mới`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `Nhập tên người nhận`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `Gán cho khách`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `Hủy`,
    'menu-item.group-ordering.recipient-picker.title': `Dành cho ai?`,
    'menu-item.group-ordering.recipient-picker.add-new': `Thêm mới`,
    'menu-item.nested-mod-groups.edit': `Chỉnh sửa`,
    'menu-item.nested-mod-groups.popup.done': `Xong`,
    'menu-item.nested-mod-groups.popup.cancel': `Hủy`,
    'menu-item.nested-mod-groups.popup.back': `Quay lại`,
    'menu-item.nested-mod-groups.popup.next': `Tiếp`,
    'checkout.cart.remove-item-verification.title': `Yêu cầu xác minh của quản lý`,
    'checkout.cart.remove-item-verification.description': `Cần mã truy cập của nhân viên để xóa món hàng này khỏi giỏ hàng. Xin hãy nhờ nhân viên hỗ trợ.`,
    'checkout.cart.confirm-remove-item.title': `Xóa món hàng?`,
    'checkout.cart.confirm-remove-item.description': `Bạn có chắc chắn muốn xóa {{$1: item name}} khỏi giỏ hàng của bạn?`,
    'checkout.cart.confirm-remove-item.cancel': `Hủy`,
    'checkout.cart.confirm-remove-item.confirm': `Xóa`,
    'checkout.cart.pre-checkout-recommendations.title': `Hoàn tất đơn hàng của bạn`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `Tiếp tục`,
    'checkout.cart.pre-checkout-recommendations.back-button': `Quay lại`,
    'checkout.cart.item-86d.title.items': `Một số món hàng không còn khả dụng`,
    'checkout.cart.item-86d.title.mods': `Một số tùy chỉnh không còn khả dụng`,
    'checkout.cart.item-86d.title.mixed': `Một số món hàng và tùy chỉnh không còn khả dụng`,
    'checkout.cart.item-86d.description.items': `Các món hàng sau đã được xóa khỏi giỏ hàng của bạn:`,
    'checkout.cart.item-86d.description.mods': `Các tùy chỉnh sau đã được xóa khỏi món hàng của bạn:`,
    'checkout.cart.item-86d.description.mixed': `Những mục sau không còn khả dụng và đã bị xóa:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (trong {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `Chỉnh sửa`,
    'checkout.payment-options.tip.invalid-tip-amount': `Xin lỗi, bạn không thể áp dụng tiền tip lớn hơn tổng đơn hàng. Xin hãy nhập một giá trị tip nhỏ hơn tổng phụ của đơn hàng trừ đi các khoản giảm giá.`,
    'checkout.payment-options.name.title': `Xin chào, {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `Chọn phương thức thẻ quà tặng`,
    'checkout.payment-options.gift-cards.prompt.default-option': `Thẻ quà tặng`,
    'checkout.payment-options.pay-with-cash-machine.label': `Chạm để thanh toán bằng máy tiền mặt`,
    'checkout.payment-options.pay-with-cash-machine.button': `Tiền mặt`,
    'checkout.payment-options.donation.or': `HOẶC`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `Thông tin phí dịch vụ`,
    'checkout.payment-options.credit-card.button.zero-balance': `Đặt hàng`,
    'checkout.payment-options.inline-loyalty.view-all': `Xem tất cả phần thưởng`,
    'checkout.payment-options.inline-loyalty.apply': `Áp dụng phần thưởng`,
    'checkout.payment-options.inline-loyalty.greeting': `Xin chào, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.star-balance': `Số dư sao: {{$1: stars}}\u2605`,
    'checkout.payment-options.inline-loyalty.celebration.title': `Chúc mừng sinh nhật!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `Chúc mừng sinh nhật, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `Hãy tận hưởng món quà của bạn!`,
    'checkout.payment-options.inline-loyalty.error.title': `Không thể áp dụng phần thưởng`,
    'checkout.payment-options.inline-loyalty.error.message': `Đã xảy ra lỗi khi áp dụng phần thưởng của bạn. Xin vui lòng thử lại.`,
    'loyalty.starbucks.header.redeemable-stars': `Sao có thể đổi`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}\u2605 hết hạn vào {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `Sao của bạn sẽ không hết hạn`,
    'loyalty.starbucks.progress.next-status-by-date': `Kiếm {{$1: stars}}\u2605 trước {{$2: date}} để đạt cấp {{$3: level}}`,
    'loyalty.starbucks.progress.next-status': `Kiếm {{$1: stars}}\u2605 để đạt cấp {{$2: level}}`,
    'loyalty.starbucks.progress.maintain-status-by-date': `Kiếm {{$1: stars}}\u2605 trước {{$2: date}} để gia hạn cấp {{$3: level}} của bạn thêm một năm`,
    'loyalty.starbucks.progress.maintain-status': `Kiếm {{$1: stars}}\u2605 để gia hạn cấp {{$2: level}} của bạn thêm một năm`,
    'loyalty.starbucks.progress.extended': `Đã gia hạn thêm một năm`,
    'loyalty.starbucks.progress.annual-earned': `Đã kiếm trong năm`,
    'loyalty.starbucks.progress.status-target': `Cấp {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `để gia hạn`,
    'loyalty.starbucks.birthday.title': `Chúc mừng sinh nhật, {{$1: name}}!`,
    'loyalty.starbucks.birthday.title-no-name': `Chúc mừng sinh nhật!`,
    'loyalty.starbucks.birthday.redeem': `Đổi coupon sinh nhật của bạn!`,
    'loyalty.starbucks.birthday.description': `Hãy tận hưởng thức uống hoặc món yêu thích của bạn, chúng tôi mời. Đổi khi thanh toán, hoặc báo cho barista của bạn khi gọi món.`,
    'loyalty.starbucks.birthday.valid-until': `Có hiệu lực đến {{$1: date}}`,
    'loyalty.starbucks.member-since': `Thành viên từ {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `Cảm ơn bạn đã là thành viên trung thành của Starbucks Rewards.`,
    'checkout.paying.starbucks.title': `Xin hãy quét mã QR trên app Starbucks của bạn ngay bây giờ`,
    'checkout.paying.starbucks.subtitle': `Xin hãy đảm bảo bạn đã sẵn sàng tính năng Scan to Pay trong app Starbucks để hoàn tất đơn hàng của bạn.`,
    'checkout.paying.starbucks.cancel-button': `Hủy`,
    'checkout.paying.error.loyalty-payment': `Xin lỗi, chúng tôi không thể xử lý thanh toán của bạn. Xin vui lòng thử lại.`,
    'checkout.paying.error.pos.print': `Tiếp tục và in hóa đơn`,
    'checkout.paying.error.table-tracker.print': `Tiếp tục và in hóa đơn`,
    'checkout.paying.error.table-tracker.title': `Rất tiếc! Chúng tôi không thể lấy máy tracker của bạn.`,
    'checkout.paying.error.table-tracker.instructions': `Đơn hàng của bạn đã được xử lý, nhưng đã xảy ra lỗi khi phát máy tracker để theo dõi đơn hàng của bạn. Hãy tiếp tục đến bước tiếp theo để nhận hóa đơn của bạn.`,
    'checkout.paying.error.title': `Rất tiếc!`,
    'checkout.paying.sending-table-tracker-request.title': `Đang phát máy tracker`,
    'checkout.paying.sending-table-tracker-request.subtitle': `Xin hãy đợi trong khi chúng tôi phát máy tracker của bạn.`,
    'checkout.paying.cash-machine.pinging.title': `Đang kiểm tra máy tiền mặt`,
    'checkout.paying.cash-machine.pinging.subtitle': `Xin hãy đợi trong khi chúng tôi kiểm tra xem máy tiền mặt có khả dụng không.`,
    'checkout.paying.cash-machine.awaiting.title': `Máy tiền mặt đang được sử dụng`,
    'checkout.paying.cash-machine.awaiting.subtitle': `Xin hãy đợi cho đến khi máy tiền mặt khả dụng.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `Hủy`,
    'checkout.paying.cash-machine.receiving.title': `Máy tiền mặt đã sẵn sàng`,
    'checkout.paying.cash-machine.receiving.subtitle': `Xin hãy đưa khoản thanh toán của bạn vào máy tiền mặt.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `Hủy`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `Hủy và hoàn tiền thanh toán`,
    'checkout.paying.cash-machine.receiving.partial-button': `Thanh toán phần còn lại bằng cách khác`,
    'checkout.paying.cash-machine.receiving.amount': `Còn lại {{$1: amount}}`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `Xin hãy lấy tất cả tiền giấy và tiền xu từ máy tiền mặt.`,
    'checkout.paying.cash-machine.cancelling.title': `Đang hủy thanh toán bằng máy tiền mặt`,
    'checkout.paying.cash-machine.cancelling.subtitle': `Xin hãy lấy tất cả tiền giấy và tiền xu từ máy tiền mặt.`,
    'checkout.paying.cash-machine.cancelling.error.title': `Lỗi khi hủy thanh toán bằng máy tiền mặt`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `Không thể hủy thanh toán của bạn. Xin hãy nhờ nhân viên giúp đỡ.`,
    'checkout.paying.cash-machine.cancelling.error.print': `Tiếp tục và in hóa đơn`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `Không đủ tiền thối`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `Máy tiền mặt không thể thối tiền cho khoản thanh toán của bạn, vì vậy chúng tôi đã hoàn lại khoản thanh toán của bạn.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `Thử lại`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `Quay lại`,
    'checkout.paying.cash-machine.error.message': `Máy tiền mặt không thể xử lý thanh toán của bạn. Xin vui lòng thử lại.`,
    'checkout.done.details.guest-name': `Tên`,
    'checkout.done.details.table-number': `Số bàn`,
    'checkout.done.details.tracker-number': `Số tracker`,
    'checkout.done.details.order-number': `Mã đơn hàng`,
    'checkout.done.error.table-tracker.instructions': `Đã xảy ra lỗi khi lấy máy tracker của bạn. Đơn hàng của bạn đã được xử lý thành công. Xin hãy nhờ nhân viên giúp đỡ.`,
    'checkout.done.qr-code.error': `Xin lỗi, chúng tôi không thể tạo mã QR cho hóa đơn của bạn.`,
    'printer-receipt.stored-value-remaining-balance': `Số dư còn lại của {{$1: label}}`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `Tùy chọn dùng bữa bạn đã chọn không còn khả dụng. Đơn hàng của bạn đã được cập nhật để dùng “{{$1: dining option name}}”.`,
    'order-reconciler.error.items-unavailable': `Một số món hàng trong đơn hàng của bạn không còn khả dụng. Đơn hàng của bạn đã được cập nhật để xóa các món hàng không khả dụng. Các món hàng sau đã bị xóa: {{$1: item names}}`,
    'page-nav.order-history-item.title': `Đơn hàng của bạn`,
    'page-nav.order-history-item.cta': `Xem đơn hàng của tôi`,
    'print.error.phone-number-label': `Số điện thoại`,
    'print.error.guest-name-label': `Tên`,
    'print.error.table-number-label': `Số bàn`,
    'print.error.tracker-number-label': `Số tracker`,
    'print.error.order-number-label': `Mã đơn hàng`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.vi-vn.js.map